import * as React from 'react';
import * as _ from 'underscore';

import NumberField from '../../../../_common/platform/tsx/NumberField';
import StringField from '../../../../_common/platform/tsx/StringField';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import NumberSpinnerExtended from '../../../../_common/platform/tsx/NumberSpinnerExtended';
import DateField from '../../../../_common/platform/tsx/DateField';
import SelectField, { ISelectFieldOptions } from '../../../../_common/platform/tsx/SelectField';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';
import { FontField } from '../../../../_common/platform/tsx/FontField';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import { chartConstants } from '../../../../pdc-widget-chart/src/ts/chartConstants';
import { themeFields } from '../../../../pdc-widget-chart/src/ts/themes/themeFields';
import { ChartPropsManager } from '../ChartPropsManager';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';

import { ATTRIBUTE_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';
import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

const Globalize = require('pdc-platform-Globalize');

const undefDataType = chartConstants.dataTypes.undefDataType;
const arrCommonDataTypes = chartConstants.dataTypes.arrCommonDataTypes;
const arrTimePartTypes = chartConstants.dataTypes.arrTimePartTypes;
const stdCulture = 'en'; //LL: time format is hh:mm:ss

//LL: themeFields_forDefaultColors is set to null in case of inheritanceShow
export function normalizeChartAxisField(
    value,
    kind,
    themeObj: appTheme.IValuesCollection,
    themeFields_forDefaultColors,
    dataTypeExt
) {
    // - Color:

    if (themeObj != null && themeFields_forDefaultColors != null) {
        let theme_color = themeObj[themeFields_forDefaultColors.themeFieldForDefault_color];

        if (value.color == null) {
            value.color = theme_color;
        }

        let theme_colorLabels = themeObj[themeFields_forDefaultColors.themeFieldForDefault_colorLabels];

        if (value.colorLabels == null) {
            value.colorLabels = theme_colorLabels;
        }

        //  only for "a":
        let theme_colorSeries = themeObj[themeFields_forDefaultColors.themeFieldForDefault_colorSeries];

        if (value.colorSeries == null) {
            value.colorSeries = theme_colorSeries;
        }

        let theme_colorBreaks = themeObj[themeFields_forDefaultColors.themeFieldForDefault_colorBreaks];

        if (value.breaksColor == null) {
            value.breaksColor = theme_colorBreaks;
        }
    }
    // old:
    else if (kind === 'a' || kind === 'A') {
        if (value.colorSeries == null) {
            value.colorSeries = '#ff0080';
        }
    }

    // - Depending on DataType:  (not Inherited Predefined DataType): LabelFormat, Precision, Min/Max
    let dataType;

    if (typeof dataTypeExt === 'string') {
        // old
        dataType = dataTypeExt;
    } else {
        // new  now for X
        dataType = dataTypeExt.type;

        if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
            dataType = dataTypeExt.timePart;
        }
    }

    value.dataType = dataType;

    let fnd = false;
    let arr = ['default'];

    switch (dataType) {
        case 'i':
        case 'r':
            // if (typeof getFormatFrontArray_Numeric_Func === 'function') {
            //     arr = getFormatFrontArray_Numeric_Func();
            // }
            arr = ChartPropsManager.getFormatFrontArray_Numeric();

            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === value.labelFormat) {
                    fnd = true;
                    break;
                }
            }

            if (fnd) {
                delete value.labelHasCustomFormat;
            }
            if (!fnd) {
                let arrTimeIntervalFormats = [];

                if (dataType === ATTRIBUTE_TYPES.INTEGER) {
                    // if (typeof getFormatFrontArray_TimeIntervals_Int_Func === 'function') {
                    //     arrTimeIntervalFormats = getFormatFrontArray_TimeIntervals_Int_Func();
                    // }
                    arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Int();

                    //LL: formatting Integers as TimeParts
                    let arrTimePartsFormats = ChartPropsManager.integer_TimePartFormats();
                    arrTimeIntervalFormats = arrTimeIntervalFormats.concat(arrTimePartsFormats);
                }

                if (dataType === ATTRIBUTE_TYPES.REAL) {
                    // if (typeof getFormatFrontArray_TimeIntervals_Real_Func === 'function') {
                    //     arrTimeIntervalFormats = getFormatFrontArray_TimeIntervals_Real_Func();
                    // }
                    arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Real();
                }

                for (let i = 0; i < arrTimeIntervalFormats.length; i++) {
                    if (arrTimeIntervalFormats[i] === value.labelFormat) {
                        fnd = true;
                        break;
                    }
                }
                if (fnd) {
                    value.labelHasCustomFormat = true;
                }
            }

            if (!fnd) {
                delete value.labelFormat;
                delete value.labelHasCustomFormat;
            }
            break;

        case 'datetime':
        case 'date':
            const getFormatFunc =
                dataType === 'date'
                    ? ChartPropsManager.getFormatFrontArray_Date //getFormatFrontArray_Date_Func
                    : ChartPropsManager.getFormatFrontArray_DateTime; //getFormatFrontArray_DateTime_Func;

            arr = getFormatFunc();

            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === value.labelFormat) {
                    fnd = true;
                    break;
                }
            }
            if (!fnd) {
                delete value.labelFormat;
            }

            if (value.labelFormat === 'default') {
                delete value.labelFormat;
            }

            delete value.labelPrecision;
            delete value.labelHasCustomFormat;
            break;

        case 'time':
            // if (typeof getFormatFrontArray_Time_Func === 'function') {
            //     arr = getFormatFrontArray_Time_Func();
            // }
            arr = ChartPropsManager.getFormatFrontArray_Time();

            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === value.labelFormat) {
                    fnd = true;
                    break;
                }
            }

            if (!fnd) {
                delete value.labelFormat;
            }

            if (value.labelFormat === 'default') {
                delete value.labelFormat;
            }

            delete value.labelPrecision;
            delete value.labelHasCustomFormat;
            break;

        case 's':
        case 'e':
        case 'b':
            delete value.labelFormat;
            delete value.labelPrecision;
            delete value.labelHasCustomFormat;
            break;

        default:
            // now can be TimePart
            // if (typeof getFormatFrontArray_TimePart_Func === 'function') {
            //     arr = getFormatFrontArray_TimePart_Func(dataType);
            // }
            arr = ChartPropsManager.integer_TimePartFormats();

            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === value.labelFormat) {
                    fnd = true;
                    break;
                }
            }

            if (!fnd) {
                delete value.labelFormat;
            }

            delete value.labelPrecision;
            delete value.labelHasCustomFormat;
            break;
    }

    if (value.tickDateIntervalType === 'none') {
        delete value.tickDateIntervalType;
    }

    if (value.minValue == null) {
        value.useMinValue = false;
    } else {
        if (value.useMinValue != true) {
            value.useMinValue = value.minValue != null;
        }
    }

    if (value.maxValue == null) {
        value.useMaxValue = false;
    } else {
        if (value.useMaxValue != true) {
            value.useMaxValue = value.maxValue != null;
        }
    }

    if (dataType === 'time') {
        //LL: needed when switch from null to a value, date part in such case is today
        if (value.minValue != null) {
            let ttt = DateTimeFunctions.convertTimeStringToDate(value.minValue); // it is of type datetime

            if (ttt != null) {
                // set 02.01.1970 and to string
                ttt.setYear(DateTimeFunctions.TimeDefaultDate.year);
                ttt.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                ttt.setDate(DateTimeFunctions.TimeDefaultDate.day);
                value.minValue = Globalize(stdCulture).formatDate(ttt, {
                    raw: DateTimeFunctions.TimeValueFormat
                });
            }
        }

        if (value.maxValue != null) {
            let ttt = DateTimeFunctions.convertTimeStringToDate(value.maxValue); // it is of type datetime

            if (ttt != null) {
                // set 02.01.1970 and to string
                ttt.setYear(DateTimeFunctions.TimeDefaultDate.year);
                ttt.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                ttt.setDate(DateTimeFunctions.TimeDefaultDate.day);
                value.maxValue = Globalize(stdCulture).formatDate(ttt, {
                    raw: DateTimeFunctions.TimeValueFormat
                });
            }
        }
    }
}

function makeListOptions(values: any[]) {
    return _.map(values, (val, index) => {
        return (
            <option key={val + '_' + index} value={val}>
                {val}
            </option>
        );
    });
}

export interface IChartAxisFieldOptions_inThemes extends IParameterFieldBaseOptions {
    name: string;
    kind;
    widgetTypeName?: string;
    widgetValues?;
    themeFieldForAxisList?;
    canRemove?: boolean;
    useInheritedButton?: boolean;
    getModifiedValuesAndDisplay_Full_Func(values, glob: IGlob, axisName: string): { values; display };
    themeFields_forDefaultColors;

    canAxisLabelPrecision_byLabelFormat_Func;
    getDataType_Func(values, glob: IGlob): { type?: string; timePart? };
    is_fullStackedOnAxis_Func?;
    isMultiValueAxis_Func?;
    isAssignedSecondaryAxis_Func?;
    hasAxis_Bubble_Func?;

    onRemove?(name: string): void;
}

export default class ChartAxisField_inThemes extends React.Component<
    {
        value?;
        options?: IChartAxisFieldOptions_inThemes;
        themeObj?: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value): void;
    },
    any
> {
    private references: {
        position?: HTMLElement;
        breaksLineStyle?: HTMLElement;
        usePalette?: HTMLElement;
        inverted?: HTMLElement;
        fontItalic?: HTMLElement;
        breaksAutoEnabled?: HTMLElement;
        tickDateIntervalType?: HTMLElement;
        bubbleSizeFormat?: HTMLElement;
        labelFormat?: HTMLElement;
        selectAxis?: HTMLElement;
        selectPredefinedDataType?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);
        //LL: and changing this.props.value here is very strange !?
        //LL:  wrong (prohibited) axis type (mainly 'continuous'):
        let wrongAxisType = null;

        if (props.value.type != null && props.value.type !== 'default') {
            let kind = 'x';

            if (props.options != null && props.options.kind != null) {
                kind = props.options.kind;
            }

            let types = this.getTypes(kind, props.value); // arrays inside {}
            let dataTypePredefined = props.value.dataTypePredefined;

            if (dataTypePredefined != null) {
                //LL: presume Predefined is always of kind = 'a'
                //LL: canRemove when Axis is not assigned, so dataType is actually undefined
                let canRemove = true;

                if (props.options.canRemove != null) {
                    canRemove = props.options.canRemove;
                }

                if (canRemove) {
                    //LL: canRemove when Axis is not assigned, so dataType is actually undefined
                    let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataTypePredefined);
                    let validAxisTypes = chartConstants.axisTypes.undef;

                    if (isTimePart) {
                        validAxisTypes = chartConstants.axisTypes.timePart;
                    } else if (chartConstants.axisTypes[dataTypePredefined] != null) {
                        validAxisTypes = chartConstants.axisTypes[dataTypePredefined];
                    }

                    types.values = validAxisTypes;
                }
            }

            let type = props.value.type;
            let find = _.find(types.values, function (val) {
                if (val === type) {
                    return true;
                }
            });

            if (find == null) {
                console.log(
                    '  ---- ChartAxisField constructor: WRONG props.value.type = ' +
                        props.value.type +
                        ' kind = ' +
                        kind +
                        ' name = ' +
                        props.value.name
                );
                console.log('  ---- ChartAxisField constructor: allowed types.values = ' + types.values);
                console.log('  ---- ChartAxisField constructor: props.value.type is cleared');

                wrongAxisType = type;

                //props.value.type = 'default';
                delete props.value.type; //LL: this is indecent ? Error must be shown - yes, see in render
            }
        }

        this.state = {
            wrongAxisType: wrongAxisType,
            selectedPredefinedAxis: null
        };
    }

    public static numberOfEditedItems(ownValues, parentValues) {
        if (ownValues == null) {
            return 0;
        }

        //LL:  except "dataType", "useMinValue", "useMaxValue"   Also "name" - for AUX

        let keysArr = _.keys(ownValues); // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]
        keysArr = _.without(keysArr, 'dataType', 'useMinValue', 'useMaxValue', 'name');
        if (parentValues == null) {
            return keysArr.length;
        } else {
            let ownKeys = [];
            _.each(keysArr, function (obj) {
                if (parentValues[obj] == null || parentValues[obj] !== ownValues[obj]) {
                    ownKeys.push(obj);
                }
            });
            return ownKeys.length;
        }
    }

    normalize(value) {
        //let kind = this.props.options.kind;
        // - labelFormat, labelPrecision:
        let dataTypeExt: any = this._get_dataType(this.props.options.kind);
        let dataType;

        if (typeof dataTypeExt === 'string') {
            // old
            dataType = dataTypeExt;
        } else {
            // new  now for X
            dataType = dataTypeExt.type;
            if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
                dataType = dataTypeExt.timePart;
            }
        }

        //LL: predefined old for 'a'
        let dataTypePredefined = this.getDataTypePredefined(value); //LL: canRemove inside
        if (dataTypePredefined != null) {
            dataType = dataTypePredefined;

            let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataTypePredefined);

            if (isTimePart) {
            } else {
                switch (dataTypePredefined) {
                    case 'integer':
                        dataType = 'i';
                        break;
                    case 'real':
                        dataType = 'r';
                        break;
                    case 'string':
                    case chartConstants.dataTypes.undefDataType:
                        dataType = 's';
                        break;
                }
            }
        }

        value.dataType = dataType;

        //LL: dataType_current instead of dataType  when with standard inheritance
        let forActualChart = true; //LL: false when with standard inheritance, on upper levels
        let props_values = this.get_props_values();

        if (props_values == null) {
            forActualChart = false; //LL: when with standard inheritance, on upper levels
        }
        //LL: when with standard inheritance, on upper levels (dataType is not defined)

        let dataType_current = dataType;

        if (!forActualChart) {
            let inheritedPredefinedDataType = value.inheritedPredefinedDataType || undefDataType;

            dataType_current = inheritedPredefinedDataType;

            let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataType_current);

            if (isTimePart) {
            } else {
                switch (inheritedPredefinedDataType) {
                    case 'integer':
                        dataType_current = 'i';
                        break;
                    case 'real':
                        dataType_current = 'r';
                        break;
                    case 'string':
                    case chartConstants.dataTypes.undefDataType:
                        dataType_current = 's';
                        break;
                }
            }
        }

        let fnd = false;
        let arr = ['default'];

        switch (dataType_current) {
            case 'i':
            case 'r':
                // if (typeof this.props.options?.getFormatFrontArray_Numeric_Func === 'function') {
                //     arr = this.props.options.getFormatFrontArray_Numeric_Func();
                // }
                arr = ChartPropsManager.getFormatFrontArray_Numeric();

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] === value.labelFormat) {
                        fnd = true;
                        break;
                    }
                }

                if (fnd) {
                    delete value.labelHasCustomFormat;
                }
                if (!fnd) {
                    let arrTimeIntervalFormats = [];

                    if (dataType_current === ATTRIBUTE_TYPES.INTEGER) {
                        // if (typeof this.props.options?.getFormatFrontArray_TimeIntervals_Int_Func === 'function') {
                        //     arrTimeIntervalFormats = this.props.options.getFormatFrontArray_TimeIntervals_Int_Func();
                        // }
                        arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Int();
                        //LL: formatting Integers as TimeParts
                        //if (this.props.options != null) {
                        const arrTimePartsFormats = ChartPropsManager.integer_TimePartFormats();

                        arrTimeIntervalFormats = arrTimeIntervalFormats.concat(arrTimePartsFormats);
                        //}
                    }

                    if (dataType_current === ATTRIBUTE_TYPES.REAL) {
                        // if (typeof this.props.options?.getFormatFrontArray_TimeIntervals_Real_Func === 'function') {
                        //     arrTimeIntervalFormats = this.props.options.getFormatFrontArray_TimeIntervals_Real_Func();
                        // }
                        arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Real();
                    }

                    for (let i = 0; i < arrTimeIntervalFormats.length; i++) {
                        if (arrTimeIntervalFormats[i] === value.labelFormat) {
                            fnd = true;
                            break;
                        }
                    }
                    if (fnd) {
                        value.labelHasCustomFormat = true;
                    }
                }

                if (!fnd) {
                    delete value.labelFormat;
                    delete value.labelHasCustomFormat;
                }
                break;

            case 'datetime':
            case 'date':
                if (this.props.options != null) {
                    let getFormatFunc =
                        dataType_current === 'date'
                            ? ChartPropsManager.getFormatFrontArray_Date //this.props.options.getFormatFrontArray_Date_Func
                            : ChartPropsManager.getFormatFrontArray_DateTime; //this.props.options.getFormatFrontArray_DateTime_Func;

                    if (typeof getFormatFunc === 'function') {
                        arr = getFormatFunc();
                    }
                }

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] === value.labelFormat) {
                        fnd = true;
                        break;
                    }
                }
                if (!fnd) {
                    delete value.labelFormat;
                }

                if (value.labelFormat === 'default') {
                    delete value.labelFormat;
                }

                delete value.labelPrecision;
                delete value.labelHasCustomFormat;
                break;

            case 'time':
                // if (typeof this.props.options?.getFormatFrontArray_Time_Func === 'function') {
                //     arr = this.props.options.getFormatFrontArray_Time_Func();
                // }
                arr = ChartPropsManager.getFormatFrontArray_Time();

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] === value.labelFormat) {
                        fnd = true;
                        break;
                    }
                }
                if (!fnd) {
                    delete value.labelFormat;
                }

                if (value.labelFormat === 'default') {
                    delete value.labelFormat;
                }

                delete value.labelPrecision;
                delete value.labelHasCustomFormat;
                break;

            case 's':
            case 'e':
            case 'b':
                delete value.labelFormat;
                delete value.labelPrecision;
                delete value.labelHasCustomFormat;
                break;

            default:
                // now can be TimePart
                // if (typeof this.props.options?.getFormatFrontArray_TimePart_Func === 'function') {
                //     arr = this.props.options.getFormatFrontArray_TimePart_Func(dataType_current);
                // }
                arr = ChartPropsManager.integer_TimePartFormats();

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] === value.labelFormat) {
                        fnd = true;
                        break;
                    }
                }

                if (!fnd) {
                    delete value.labelFormat;
                }

                delete value.labelPrecision;
                delete value.labelHasCustomFormat;
                break;
        }

        // - tickDateIntervalType
        if (value.tickDateIntervalType === 'none') {
            delete value.tickDateIntervalType;
        }

        if (value.minorTickCount <= 0) {
            delete value.minorTickCount;
        }

        if (value.axisDivisionFactor <= 0) {
            delete value.axisDivisionFactor;
        }

        if (value.labelPrecision < 0) {
            delete value.labelPrecision;
        }

        if (value.bubbleSizePrecision < 0) {
            delete value.bubbleSizePrecision;
        }

        if (value.minValue == null) {
            value.useMinValue = false;
        } else {
            if (value.useMinValue != true) {
                value.useMinValue = value.minValue != null;
            }
        }

        if (value.maxValue == null) {
            value.useMaxValue = false;
        } else {
            if (value.useMaxValue != true) {
                value.useMaxValue = value.maxValue != null;
            }
        }

        if (dataType_current === 'time') {
            //LL: needed when switch from null to a value, date part in such case is today
            if (value.minValue != null) {
                let ttt = DateTimeFunctions.convertTimeStringToDate(value.minValue); // it is of type datetime
                if (ttt != null) {
                    // set 02.01.1970 and to string
                    ttt.setYear(DateTimeFunctions.TimeDefaultDate.year);
                    ttt.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                    ttt.setDate(DateTimeFunctions.TimeDefaultDate.day);
                    value.minValue = Globalize(stdCulture).formatDate(ttt, {
                        raw: DateTimeFunctions.TimeValueFormat
                    });
                }
            }

            if (value.maxValue != null) {
                let ttt = DateTimeFunctions.convertTimeStringToDate(value.maxValue); // it is of type datetime
                if (ttt != null) {
                    // set 02.01.1970 and to string
                    ttt.setYear(DateTimeFunctions.TimeDefaultDate.year);
                    ttt.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                    ttt.setDate(DateTimeFunctions.TimeDefaultDate.day);
                    value.maxValue = Globalize(stdCulture).formatDate(ttt, {
                        raw: DateTimeFunctions.TimeValueFormat
                    });
                }
            }
        }

        if (value.topMargin != null) {
            value.maxMargin = value.topMargin / 100;
        } else {
            delete value.maxMargin;
        }
        if (value.bottomMargin != null) {
            value.minMargin = value.bottomMargin / 100;
        } else {
            delete value.minMargin;
        }
    }

    //LL: mostly for kind 'a'
    getDataTypePredefined(value?) {
        let val = value != null ? value : this.props.value;
        let dataTypePredefined = val.dataTypePredefined;
        if (dataTypePredefined != null) {
            //LL: presume Predefined is always of kind = 'a'
            //LL: canRemove when Axis is not assigned, so dataType is actually undefined
            let canRemove = true;
            if (this.props.options.canRemove != null) {
                canRemove = this.props.options.canRemove;
            }

            if (!canRemove) {
                dataTypePredefined = null;
            }
        }
        return dataTypePredefined;
    }

    handleValueChange(value) {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    changeShow = (newShow) => {
        let obj = _.clone(this.props.value || {});

        if (newShow == null) {
            delete obj.show;
        } else {
            obj.show = newShow;
        }

        this.handleValueChange(obj);
    };

    changeShowLine = (newShowLine) => {
        let obj = _.clone(this.props.value || {});

        if (newShowLine == null) {
            delete obj.showLine;
        } else {
            obj.showLine = newShowLine;
        }

        this.handleValueChange(obj);
    };

    changeShowGridLines = (newShowGridLines) => {
        let obj = _.clone(this.props.value || {});

        if (newShowGridLines == null) {
            delete obj.showGridLines;
        } else {
            obj.showGridLines = newShowGridLines;
        }

        this.handleValueChange(obj);
    };

    changeShowAxisTicks = (newShowAxisTicks) => {
        let obj = _.clone(this.props.value || {});
        if (newShowAxisTicks == null) {
            delete obj.showAxisTicks;
        } else {
            obj.showAxisTicks = newShowAxisTicks;
        }
        this.handleValueChange(obj);
    };

    changeShowMinorTicks = (newShowMinorTicks) => {
        let obj = _.clone(this.props.value || {});
        if (newShowMinorTicks == null) {
            delete obj.showMinorTicks;
        } else {
            obj.showMinorTicks = newShowMinorTicks;
        }
        this.handleValueChange(obj);
    };

    changeShowMinorGridLines = (newShowMinorGridLines) => {
        let obj = _.clone(this.props.value || {});
        if (newShowMinorGridLines == null) {
            delete obj.showMinorGridLines;
        } else {
            obj.showMinorGridLines = newShowMinorGridLines;
        }
        this.handleValueChange(obj);
    };

    changeShowLabels = (newShowLabels) => {
        let obj = _.clone(this.props.value || {});
        if (newShowLabels == null) {
            delete obj.showLabels;
        } else {
            obj.showLabels = newShowLabels;
        }
        this.handleValueChange(obj);
    };

    processTitleChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.title;
        } else {
            obj.title = val;
        }
        this.handleValueChange(obj);
    };

    processPositionChange = (e) => {
        let val = (this.references.position as HTMLInputElement).value;

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.position;
        } else {
            obj.position = val;
        }
        this.handleValueChange(obj);
    };

    processBreaksLineStyleChange = (e) => {
        let val = (this.references.breaksLineStyle as HTMLInputElement).value;

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.breaksLineStyle;
        } else {
            obj.breaksLineStyle = val;
        }
        this.handleValueChange(obj);
    };

    //LL: ownKeys, for clearElem param is null
    processWidthChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.width;
        } else {
            obj.width = val;
        }
        this.handleValueChange(obj);
    };

    //LL: old
    processMaxMarginChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.maxMargin;
        } else {
            obj.maxMargin = val;
        }
        this.handleValueChange(obj);
    };
    processMinMarginChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.minMargin;
        } else {
            obj.minMargin = val;
        }
        this.handleValueChange(obj);
    };

    //LL: "Top Margin", "Bottom Margin":  percents 0-100
    processTopMarginChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.topMargin;
        } else {
            obj.topMargin = val;
        }
        this.handleValueChange(obj);
    };
    processBottomMarginChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.bottomMargin;
        } else {
            obj.bottomMargin = val;
        }
        this.handleValueChange(obj);
    };

    processBreaksWidthChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.breaksWidth;
        } else {
            obj.breaksWidth = val;
        }
        this.handleValueChange(obj);
    };

    processBreaksAutoMaxCountChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.breaksAutoMaxCount;
        } else {
            obj.breaksAutoMaxCount = val;
        }
        this.handleValueChange(obj);
    };

    processColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.color;
        } else {
            obj.color = val;
        }
        this.handleValueChange(obj);
    };

    processColorLabelsChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.colorLabels;
        } else {
            obj.colorLabels = val;
        }
        this.handleValueChange(obj);
    };

    processBreaksColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.breaksColor;
        } else {
            obj.breaksColor = val;
        }
        this.handleValueChange(obj);
    };

    processColorSeriesChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.colorSeries;
        } else {
            obj.colorSeries = val;
        }
        this.handleValueChange(obj);
    };

    processUsePaletteChange = (e) => {
        let val = (this.references.usePalette as HTMLInputElement).checked; //LL: not value

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.usePalette;
        } else {
            obj.usePalette = val;
        }
        this.handleValueChange(obj);
    };

    processInvertedChange = (e) => {
        let val = (this.references.inverted as HTMLInputElement).checked; //LL: not value

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.inverted;
        } else {
            obj.inverted = val;
        }
        this.handleValueChange(obj);
    };

    processFontItalicChange = (e) => {
        let val = (this.references.fontItalic as HTMLInputElement).checked; //LL: not value

        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontItalic;
        } else {
            obj.fontItalic = val;
        }
        this.handleValueChange(obj);
    };

    processFontFaceChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontFace;
        } else {
            obj.fontFace = val;
        }
        this.handleValueChange(obj);
    };

    processFontSizeChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontSize;
        } else {
            obj.fontSize = val;
        }
        this.handleValueChange(obj);
    };

    processFontWeightChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontWeight;
        } else {
            obj.fontWeight = val;
        }
        this.handleValueChange(obj);
    };

    processBreaksAutoEnabledChange = (e) => {
        let val = (this.references.breaksAutoEnabled as HTMLInputElement).checked; //LL: not value

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.breaksAutoEnabled;
        } else {
            obj.breaksAutoEnabled = val;
        }
        this.handleValueChange(obj);
    };

    processSynchronizedOnChange_N = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.synchronizedOn;
        } else {
            obj.synchronizedOn = val;
        }
        this.handleValueChange(obj);
    };

    processSynchronizedOnChange_Float = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.synchronizedOn;
        } else {
            obj.synchronizedOn = val;
        }
        this.handleValueChange(obj);
    };

    processSynchronizedOnChange_Date_N = (val) => {
        //LL:  numeric or date - depends on DataType.  Message !
        //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        let notDate = false;
        if (val === '' || val == null) {
            //val = null;
        } else {
            let date = Date.parse(val);
            if (isNaN(date)) {
                val = null;
                notDate = true;
            }
        }
        if (notDate) {
            alert('processSynchronizedOnChange_Date_N: value must be Date');
            return;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.synchronizedOn;
        } else {
            obj.synchronizedOn = val; //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        }
        this.handleValueChange(obj);
    };

    processAxisDivisionFactor = (val) => {
        //LL: null permitted
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.axisDivisionFactor;
        } else {
            obj.axisDivisionFactor = val;
        }
        this.handleValueChange(obj);
    };

    processTickIntervalChange_N = (val) => {
        //LL: null permitted
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.tickInterval;
        } else {
            obj.tickInterval = val;
        }
        this.handleValueChange(obj);
    };

    processTickIntervalChange_Float = (val) => {
        if (val === '') {
            val = null;
        }
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.tickInterval;
        } else {
            obj.tickInterval = val;
        }
        this.handleValueChange(obj);
    };

    // for Dates:
    processTickDateIntervalsChange = (val) => {
        if (val === '') {
            val = null;
        } else {
            let num = Number(val);
            if (!isNaN(num)) {
                val = num;
            } else {
                val = null;
            }
        }
        if (val != null) {
            if (val < 0) {
                val = null;
            }
        }
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.tickDateIntervals;
        } else {
            obj.tickDateIntervals = val;
        }
        this.handleValueChange(obj);
    };

    // for Dates:
    processTickDateIntervalTypeChange = (e) => {
        let val = (this.references.tickDateIntervalType as HTMLInputElement).value;

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.tickDateIntervalType;
        } else {
            obj.tickDateIntervalType = val;
        }
        this.handleValueChange(obj);
    };

    processMinorTickCountChange_NumberField = (val) => {
        //LL: use normalize ?

        //LL: try allowNull={ true }

        if (val <= 0) {
            //val = 1;
            //val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val == null) {
            delete obj.minorTickCount;
        } else {
            obj.minorTickCount = val;
        }

        this.handleValueChange(obj);
    };

    changeType = (newType) => {
        let obj = _.clone(this.props.value || {});

        if (newType == null) {
            delete obj.type;
        } else {
            obj.type = newType;
        }

        this.handleValueChange(obj);
    };

    processBubbleSizeFormatChange = (e) => {
        let val = (this.references.bubbleSizeFormat as HTMLInputElement).value;

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.bubbleSizeFormat;
        } else {
            obj.bubbleSizeFormat = val;
        }
        this.handleValueChange(obj);
    };

    processBubbleSizePrecisionChange_NumberField = (val) => {
        //LL: use normalize
        if (val < 0) {
        }
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.bubbleSizePrecision;
        } else {
            obj.bubbleSizePrecision = val;
        }
        this.handleValueChange(obj);
    };

    processLabelFormatChange = (e) => {
        //LL: use normalize for Custom Formats
        let val = (this.references.labelFormat as HTMLInputElement).value;

        //LL: ownKeys, for clearElem param is null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val == null) {
            delete obj.labelFormat;
        } else {
            obj.labelFormat = val;
        }

        this.handleValueChange(obj);
    };

    processCustomFormatChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.customFormat;
        } else {
            obj.customFormat = val;
        }
        this.handleValueChange(obj);
    };

    processLabelCurrencyChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null || val === '') {
            delete obj.labelCurrency;
        } else {
            obj.labelCurrency = val;
        }
        this.handleValueChange(obj);
    };

    processLabelPrecisionChange_NumberField = (val) => {
        //LL: use normalize
        if (val < 0) {
        }
        let obj = _.clone(this.props.value || {});

        //LL: allowNull={ true }
        if (val == null) {
            delete obj.labelPrecision;
        } else {
            obj.labelPrecision = val;
        }

        this.handleValueChange(obj);
    };

    processMinValueChange_N = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.minValue;
        } else {
            obj.minValue = val;
        }

        this.handleValueChange(obj);
    };

    processMinValueChange_Float = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.minValue;
        } else {
            obj.minValue = val;
        }
        this.handleValueChange(obj);
    };

    processMinValueChange_Date_N = (val) => {
        //LL:  numeric or date - depends on DataType.  Message !
        //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        let notDate = false;
        if (val === '' || val == null) {
            //val = null;
        } else {
            let date = Date.parse(val);
            if (isNaN(date)) {
                val = null;
                notDate = true;
            }
        }
        if (notDate) {
            alert('processMinValueChange_Date_N: value must be Date');
            return;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.minValue;
        } else {
            obj.minValue = val; //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        }
        this.handleValueChange(obj);
    };

    processMaxValueChange_N = (val) => {
        //LL: null permitted
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.maxValue;
        } else {
            obj.maxValue = val;
        }
        this.handleValueChange(obj);
    };

    processMaxValueChange_Float = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.maxValue;
        } else {
            obj.maxValue = val;
        }
        this.handleValueChange(obj);
    };

    processMaxValueChange_Date_N = (val) => {
        //LL:  numeric or date - depends on DataType.  Message !
        //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        let notDate = false;
        if (val === '' || val == null) {
            //val = null;
        } else {
            let date = Date.parse(val);
            if (isNaN(date)) {
                val = null;
                notDate = true;
            }
        }
        if (notDate) {
            alert('processMaxValueChange_Date_N: value must be Date');
            return;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.maxValue;
        } else {
            obj.maxValue = val; //LL: for "time": val = "1899-12-31T02:30:00"  => Parsed to DATE !!
        }
        this.handleValueChange(obj);
    };

    // ====================

    getTitle(value, ownKeys) {
        let titleDefault = '';
        let displayVal = value.title || titleDefault;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'title');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processTitleChange); // className="clear-button"
        }

        //  <div className="own-value inlineBlock">
        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <StringField
                        onChange={this.processTitleChange}
                        value={displayVal}
                        applyOnEnter={true}
                        changeOnBlurOnly={true}
                    />
                </div>
            </div>
        );
    }

    getPosition(value, rotated, kind, ownKeys) {
        let arr = [];
        let defVal = 'bottom';

        if (!rotated) {
            if (kind === 'x' || kind === 'X') {
                arr = ['bottom', 'top'];
                defVal = 'bottom';
            } else {
                arr = ['left', 'right'];
                if (kind === 'y' || kind === 'Y') {
                    defVal = 'left';
                } else {
                    defVal = 'right'; // Aux
                }
            }
        } else {
            if (!(kind === 'x' || kind === 'X')) {
                arr = ['bottom', 'top'];
                if (kind === 'y' || kind === 'Y') {
                    defVal = 'bottom';
                } else {
                    defVal = 'top'; // Aux
                }
            } else {
                arr = ['left', 'right'];
                defVal = 'left';
            }
        }

        //  see
        //if (!(kind === 'x' || kind === 'X')) {
        //    if (axisObj.position === 'top') axisObj.position = 'right';
        //    else if (axisObj.position === 'bottom') axisObj.position = 'left';
        //}

        const options = makeListOptions(arr);

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'position');

        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processPositionChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <select
                        ref={(input) => {
                            this.references.position = input;
                        }}
                        className="form-control"
                        onChange={this.processPositionChange}
                        value={value.position ?? defVal}
                    >
                        {options}
                    </select>
                </div>
            </div>
        );
    }

    getWidth(value, ownKeys) {
        let widthDefault = 1;

        let displayVal = value.width || widthDefault;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'width');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processWidthChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        integer={true}
                        min={1}
                        onChange={this.processWidthChange}
                    />
                </div>
            </div>
        );
    }

    //LL:   Applies only to the axes of the "continuous" and "logarithmic" types.
    getMaxMargin(value, ownKeys) {
        let displayVal = value.maxMargin; // allowNull

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'maxMargin');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processMaxMarginChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        step={0.1}
                        integer={false}
                        max={1}
                        min={0}
                        precision={1}
                        allowNull={true}
                        onChange={this.processMaxMarginChange}
                    />
                </div>
            </div>
        );
    }

    //LL:   Applies only to the axes of the "continuous" and "logarithmic" types.
    getMinMargin(value, ownKeys) {
        let displayVal = value.minMargin; // allowNull

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'minMargin');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processMinMarginChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        step={0.1}
                        integer={false}
                        max={1}
                        min={0}
                        precision={1}
                        allowNull={true}
                        onChange={this.processMinMarginChange}
                    />
                </div>
            </div>
        );
    }

    //LL:   Applies only to the axes of the "continuous" and "logarithmic" types.
    getTopMargin(value, ownKeys) {
        let displayVal = value.topMargin; // allowNull

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'topMargin');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processTopMarginChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        step={10}
                        integer={true}
                        max={100}
                        min={0}
                        allowNull={true}
                        onChange={this.processTopMarginChange}
                    />
                </div>
            </div>
        );
    }

    //LL:   Applies only to the axes of the "continuous" and "logarithmic" types.
    getBottomMargin(value, ownKeys) {
        let displayVal = value.bottomMargin; // allowNull

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'bottomMargin');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBottomMarginChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        step={10}
                        integer={true}
                        max={100}
                        min={0}
                        allowNull={true}
                        onChange={this.processBottomMarginChange}
                    />
                </div>
            </div>
        );
    }

    getBreaksLineStyle(value, ownKeys) {
        let arr = ['waved', 'straight'];
        let defVal = 'waved'; //LL: DevExpr default

        const options = makeListOptions(arr);

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'breaksLineStyle');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBreaksLineStyleChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <select
                        ref={(input) => {
                            this.references.breaksLineStyle = input;
                        }}
                        className="form-control"
                        onChange={this.processBreaksLineStyleChange}
                        defaultValue={value.breaksLineStyle ?? defVal}
                    >
                        {options}
                    </select>
                </div>
            </div>
        );
    }

    getBreaksWidth(value, ownKeys) {
        let breaksWidthDefault = 5; //LL: DevExpr default

        let displayVal = value.breaksWidth || breaksWidthDefault;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'breaksWidth');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBreaksWidthChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        integer={true}
                        min={1}
                        onChange={this.processBreaksWidthChange}
                    />
                </div>
            </div>
        );
    }

    getBreaksAutoMaxCount(value, ownKeys) {
        let breaksAutoMaxCountDefault = 4; //LL: DevExpr default

        let displayVal = value.breaksAutoMaxCount || breaksAutoMaxCountDefault;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'breaksAutoMaxCount');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBreaksAutoMaxCountChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        integer={true}
                        min={1}
                        onChange={this.processBreaksAutoMaxCountChange}
                    />
                </div>
            </div>
        );
    }

    getColor(value, ownKeys) {
        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.options.themeFields_forDefaultColors;

        let defaultColor = '#d3d3d3'; //LL: DevExpress default
        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.color != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.color;
        }

        //  1) displayVal = value.color,  without   || defaultColor;
        //  2) not isNotDefaultValue, but theme and fields
        //  3) Add:
        //  themeObj={ themeObj }
        //  options={ options }
        let options = {
            //defaultColor: defaultColor,
            //themeFieldForDefault_color: (themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_color : null)
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_color : null;

        let displayVal = value.color || themeObj[themeFieldForDefault_color] || defaultColor;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'color');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processColorChange_ColorBox); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <ColorBoxField
                        value={displayVal}
                        themeObj={themeObj}
                        hideTransparency={true}
                        showText={false}
                        options={options}
                        onChange={this.processColorChange_ColorBox}
                        glob={this.props.glob}
                    />
                </div>
            </div>
        );
    }

    getColorLabels(value, ownKeys) {
        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.options.themeFields_forDefaultColors;
        let defaultColor = '#d3d3d3'; //LL: DevExpress default

        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.colorLabels != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorLabels;
        }

        //  1) displayVal = value.color,  without   || defaultColor;
        //  2) not isNotDefaultValue, but theme and fields
        //  3) Add:
        //  themeObj={ themeObj }
        //  options={ options }
        let options = {
            hideTransparency: true
        };
        let themeFieldForDefault_colorLabels =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_colorLabels : null;
        let displayVal = value.colorLabels || themeObj[themeFieldForDefault_colorLabels] || defaultColor;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'colorLabels');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processColorLabelsChange_ColorBox); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <ColorBoxField
                        value={displayVal}
                        themeObj={themeObj}
                        hideTransparency={true}
                        showText={false}
                        options={options}
                        onChange={this.processColorLabelsChange_ColorBox}
                        glob={this.props.glob}
                    />
                </div>
            </div>
        );
    }

    getColorSeries(value, ownKeys) {
        let styleColorSeries: React.CSSProperties = {
            paddingTop: 0,
            paddingBottom: 0,
            textAlign: 'center'
        };
        let fw = 'normal';
        //LL: marginBottom default for Label is 0.5rem
        let styleLabel: React.CSSProperties = {
            fontWeight: fw,
            marginBottom: 0
        }; //LL: is "bold" by default
        let styleLabelInput: React.CSSProperties = {
            whiteSpace: 'nowrap',
            display: 'inline-block',
            marginRight: 2,
            marginTop: 0
        };
        let styleColorBox: React.CSSProperties = {
            marginLeft: 5,
            marginTop: -1,
            width: 30,
            display: 'inline-block'
        };
        let usePaletteDefault = true;
        let displayValUsePalette = value.usePalette == null ? usePaletteDefault : value.usePalette; //LL: Leo default=true
        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.options.themeFields_forDefaultColors;
        let defaultColor = '#ff0080';

        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.colorSeries != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorSeries;
        }

        let options = {
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_colorSeries : null;
        let displayVal = value.colorSeries || themeObj[themeFieldForDefault_color] || defaultColor;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'colorSeries');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processColorSeriesChange_ColorBox); // className="clear-button"
        }

        let ownKey2 = this.isOwnKey(ownKeys, 'usePalette');
        let clearElem2;

        if (ownKey2) {
            clearElem2 = this.createClearOwnElement(this.processUsePaletteChange); // className="clear-button"
        }

        return (
            <div className="form-control" style={styleColorSeries}>
                <div style={{ display: 'inline-block' }}>
                    <div className="inheritedValue">
                        {clearElem2}
                        <div className="own-value">
                            <label style={styleLabel}>
                                <input
                                    style={styleLabelInput}
                                    ref={(input) => {
                                        this.references.usePalette = input;
                                    }}
                                    type="checkbox"
                                    onChange={this.processUsePaletteChange}
                                    checked={displayValUsePalette}
                                />
                                {'Palette or'}
                            </label>
                        </div>
                    </div>
                </div>
                <div style={styleColorBox}>
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <ColorBoxField
                                value={displayVal}
                                themeObj={themeObj}
                                hideTransparency={true}
                                showText={false}
                                options={options}
                                onChange={this.processColorSeriesChange_ColorBox}
                                glob={this.props.glob}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getBreaksColor(value, ownKeys) {
        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.options.themeFields_forDefaultColors;
        let defaultColor = '#ababab'; //LL: DevExpress default

        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.colorBreaks != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorBreaks;
        }

        let options = {
            hideTransparency: true
        };
        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_colorBreaks : null;
        let displayVal = value.breaksColor || themeObj[themeFieldForDefault_color] || defaultColor;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'breaksColor');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBreaksColorChange_ColorBox); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <ColorBoxField
                        value={displayVal}
                        themeObj={themeObj}
                        hideTransparency={true}
                        showText={false}
                        options={options}
                        onChange={this.processBreaksColorChange_ColorBox}
                        glob={this.props.glob}
                    />
                </div>
            </div>
        );
    }

    getInverted(value, ownKeys) {
        let invertedDefault = false;
        let displayVal = value.inverted == null ? invertedDefault : value.inverted;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'inverted');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processInvertedChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <input
                        ref={(input) => {
                            this.references.inverted = input;
                        }}
                        type="checkbox"
                        checked={displayVal}
                        onChange={this.processInvertedChange}
                    />
                </div>
            </div>
        );
    }

    getBreaksAutoEnabled(value, ownKeys) {
        let breaksAutoEnabledDefault = false;
        let displayVal = value.breaksAutoEnabled == null ? breaksAutoEnabledDefault : value.breaksAutoEnabled;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'breaksAutoEnabled');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBreaksAutoEnabledChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <input
                        ref={(input) => {
                            this.references.breaksAutoEnabled = input;
                        }}
                        type="checkbox"
                        checked={displayVal}
                        onChange={this.processBreaksAutoEnabledChange}
                    />
                </div>
            </div>
        );
    }

    // temp as simple text:  type='number' ???
    getSynchronizedOn(value, kind, dataType, multiAxis, synchronizeMultiAxes, ownKeys) {
        if (synchronizeMultiAxes === false) {
            return;
        }

        let showSynchronizedOn = false;
        if (kind === 'a' || kind === 'A') {
            showSynchronizedOn = true;
        }
        if (kind === 'y' || kind === 'Y') {
            showSynchronizedOn = multiAxis;
        }

        if (!showSynchronizedOn) {
            return;
        }

        let displayVal = value.synchronizedOn; //LL: it is for nummeric,  allowNull={ true }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'synchronizedOn');
        let clearElem;
        //if (ownKey) {
        //    clearElem = this.createClearOwnElement(this.processBreaksAutoEnabledChange);  // className="clear-button"
        //}

        let hint = '';

        switch (dataType) {
            case 'i':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processSynchronizedOnChange_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={true}
                                applyOnEnter={true}
                                onChange={this.processSynchronizedOnChange_N}
                            />
                        </div>
                    </div>
                );

            case 'r':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processSynchronizedOnChange_Float); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={false}
                                applyOnEnter={true}
                                onChange={this.processSynchronizedOnChange_Float}
                            />
                        </div>
                    </div>
                );

            case 'datetime':
            case 'date':
                displayVal = displayVal || new Date(0); //Date.now();
                hint = value.synchronizedOn == null ? 'not set, default' : value.synchronizedOn.toString();

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processSynchronizedOnChange_Date_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                value={displayVal}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processSynchronizedOnChange_Date_N}
                            />
                        </div>
                    </div>
                );

            case 'time':
                displayVal =
                    displayVal ||
                    new Date(
                        DateTimeFunctions.TimeDefaultDate.year,
                        DateTimeFunctions.TimeDefaultDate.month - 1,
                        DateTimeFunctions.TimeDefaultDate.day,
                        0,
                        0,
                        0
                    ); // is 02.01.1970

                hint =
                    value.synchronizedOn == null
                        ? 'not set, default'
                        : DateTimeFunctions.convertTimeValueAsDateToString(value.synchronizedOn);

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processSynchronizedOnChange_Date_N); // className="clear-button"
                }

                //LL: 09.11.18: in DateField.tsx change in normalizeValue by RYB on 31.10.18 and it breaks my Chart code for "time"
                //LL: 09.11.18: to avoid it, introduce option "formattedTime = true"
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                type={'time'}
                                displayDateTimeFormat={'HH:mm:ss'}
                                value={displayVal}
                                options={{ formattedTime: true }}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processSynchronizedOnChange_Date_N}
                            />
                        </div>
                    </div>
                );

            default:
                return;
        }
    }

    //   Applies only to the axes of the "continuous" and "logarithmic" types.
    getAxisDivisionFactor(value, dataType, dataTimePart, fullStackedOnAxis, ownKeys) {
        //LL: default = not set, is null:
        //LL: hidden when type = discrete or automatic-discrete
        if (
            !(
                dataType === 'i' ||
                dataType === 'r' ||
                dataType === 'datetime' ||
                dataType === 'date' ||
                dataType === 'time'
            )
        ) {
            return;
        }
        if (value.type === 'discrete') {
            return;
        }

        let displayVal = value.axisDivisionFactor;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'axisDivisionFactor');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processAxisDivisionFactor); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        integer={true}
                        positive={true}
                        applyOnEnter={true}
                        onChange={this.processAxisDivisionFactor}
                    />
                </div>
            </div>
        );
    }

    getTickInterval(value, dataType, dataTimePart, fullStackedOnAxis, ownKeys) {
        //LL: default = not set, is null:   NOT obj.tickInterval = 1;

        //LL: hidden when type = discrete or automatic-discrete

        let displayVal = value.tickInterval;

        if (dataType === 'i' && fullStackedOnAxis) {
            dataType = 'r';
            if (displayVal == null) {
                displayVal = 0;
            }
        }

        if (dataType === 'i' && dataTimePart != null && dataTimePart !== 'none') {
            if (displayVal == null) {
                displayVal = 1;
            }
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'tickInterval');
        let clearElem;

        switch (dataType) {
            case 'i':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processTickIntervalChange_N); // className="clear-button"
                }

                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={true}
                                applyOnEnter={true}
                                onChange={this.processTickIntervalChange_N}
                            />
                        </div>
                    </div>
                );

            case 'r':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processTickIntervalChange_Float); // className="clear-button"
                }

                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={false}
                                applyOnEnter={true}
                                onChange={this.processTickIntervalChange_Float}
                            />
                        </div>
                    </div>
                );

            default:
                return;
        }
    }

    // for Dates:
    getTickDateIntervals(value, ownKeys) {
        //LL: hidden when type = discrete or automatic-discrete
        //   and only for Dates
        let tickDateIntervalsDefault = 1;
        let displayVal = value.tickDateIntervals || tickDateIntervalsDefault;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'tickDateIntervals');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processTickDateIntervalsChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <StringField
                        onChange={this.processTickDateIntervalsChange}
                        value={displayVal}
                        applyOnEnter={true}
                        changeOnBlurOnly={true}
                    />
                </div>
            </div>
        );
    }

    // for Dates:
    getTickDateIntervalType(value, dataType, ownKeys) {
        //LL: hidden when type = discrete or automatic-discrete  ?
        //   and only for Dates
        //  (dataType === 'datetime' || dataType === 'date' || dataType === 'time'

        let arr = [
            'none',
            'milliseconds',
            'seconds',
            'minutes',
            'hours',
            'days',
            'weeks',
            'months',
            'quarters',
            'years'
        ];
        if (dataType === 'time') {
            arr = ['none', 'milliseconds', 'seconds', 'minutes', 'hours'];
        }

        let tickDateIntervalTypeDefault = 'none';
        const options = makeListOptions(arr);

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'tickDateIntervalType');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processTickDateIntervalTypeChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <select
                        ref={(input) => {
                            this.references.tickDateIntervalType = input;
                        }}
                        className="form-control"
                        onChange={this.processTickDateIntervalTypeChange}
                        value={value.tickDateIntervalType || tickDateIntervalTypeDefault}
                    >
                        {options}
                    </select>
                </div>
            </div>
        );
    }

    getMinorTickCount_NumberField(value, ownKeys) {
        //LL: hidden when type = discrete or automatic-discrete
        let minorTickCountDefault = 1;
        //let displayVal = value.minorTickCount || minorTickCountDefault;
        //LL: was wrong when value.minValue == 0, because it is False, and then minValueDefault is used !
        let displayVal = value.minorTickCount;

        if (displayVal == null) {
            displayVal = minorTickCountDefault;
        }

        //LL: must be integer and >0  and allowNull=false
        //  cannot validate >0 with /tsx/NumberField, only with /ts/NumberField
        //  So, add to NumberField: positive, emptyValue

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'minorTickCount');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processMinorTickCountChange_NumberField); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        integer={true}
                        min={1}
                        onChange={this.processMinorTickCountChange_NumberField}
                    />
                </div>
            </div>
        );
    }

    getTypes = (kind, value) => {
        const { options } = this.props;
        //LL: Axis Types: discrete, continuous
        let types: ISelectFieldOptions = {}; // arrays inside {}
        let forActualChart = true; //LL: false when with standard inheritance, on upper levels
        let props_values = this.get_props_values();

        if (props_values == null) {
            //props_values = {};
            forActualChart = false; //LL: when with standard inheritance, on upper levels
        }

        //LL: use inheritedPredefinedDataType, when with standard inheritance, on upper levels
        if (!forActualChart) {
            let inheritedPredefinedDataType = value.inheritedPredefinedDataType || undefDataType;

            if (inheritedPredefinedDataType != null) {
                let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, inheritedPredefinedDataType);
                let validAxisTypes = chartConstants.axisTypes.undef;

                if (isTimePart) {
                    validAxisTypes = chartConstants.axisTypes.timePart;
                } else if (chartConstants.axisTypes[inheritedPredefinedDataType] != null) {
                    validAxisTypes = chartConstants.axisTypes[inheritedPredefinedDataType];
                }

                types.values = validAxisTypes;
                types.display = validAxisTypes.slice(0);
                types.display[0] = chartConstants.defaultAxisDisplay; // 'default' -> 'automatic'
            }
        } else {
            if (kind === 'x' || kind === 'X') {
                if (
                    props_values != null &&
                    this.props.options != null &&
                    typeof this.props.options.getModifiedValuesAndDisplay_Full_Func === 'function'
                ) {
                    types = this.props.options.getModifiedValuesAndDisplay_Full_Func(props_values, this.props.glob, options.name);
                }
            } else if (kind === 'y' || kind === 'Y') {
                if (props_values != null && typeof options?.getModifiedValuesAndDisplay_Full_Func === 'function') {
                    types = options.getModifiedValuesAndDisplay_Full_Func(props_values, this.props.glob, options.name);
                }
            } else if (kind === 'a' || kind === 'A') {
                if (props_values != null && typeof options?.getModifiedValuesAndDisplay_Full_Func === 'function') {
                    types = options.getModifiedValuesAndDisplay_Full_Func(props_values, this.props.glob, options.name);
                }

                //LL: it is old for 'a'
                let dataTypePredefined = this.getDataTypePredefined(); //LL: canRemove inside
                if (dataTypePredefined != null) {
                    let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataTypePredefined);
                    let validAxisTypes = chartConstants.axisTypes.undef;
                    if (isTimePart) {
                        validAxisTypes = chartConstants.axisTypes.timePart;
                    } else if (chartConstants.axisTypes[dataTypePredefined] != null) {
                        validAxisTypes = chartConstants.axisTypes[dataTypePredefined];
                    }

                    types.values = validAxisTypes;
                    types.display = validAxisTypes.slice(0);
                    types.display[0] = chartConstants.defaultAxisDisplay; // 'default' -> 'automatic'
                }
            }
        }

        return types;
    };

    isOwnKey(ownKeys, propName: string) {
        let ii = _.indexOf(ownKeys, propName);
        return ii >= 0;
    }

    createClearOwnElement_Bool(changeFunc) {
        return (
            <span
                style={{ marginLeft: '5px', marginRight: '3px' }}
                className="glyphicon glyphicon-remove"
                onClick={() => {
                    changeFunc(null);
                }}
            ></span>
        );
    }

    createClearOwnElement(changeFunc) {
        //  className="clear-button" is inside flex
        return (
            <span
                style={{ marginLeft: '1px', marginRight: '3px' }}
                className="glyphicon glyphicon-remove clear-button"
                onClick={() => {
                    changeFunc(null);
                }}
            ></span>
        );
    }

    getTypeInRow0(value, kind, ownKeys, forUpperLevel) {
        const types = this.getTypes(kind, value); // arrays inside {}

        let typeDefault = 'default';

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'type');

        let displayVal = value.type || typeDefault;

        let style2 = {};
        let style4 = {
            width: '130px',
            display: 'inline-block',
            marginLeft: '6px'
        };

        //LL: ownKeys try
        let clearElem;

        if (ownKey) {
            let styleClear = { marginLeft: '5px', marginRight: '2px' };
            clearElem = (
                <span
                    style={styleClear}
                    className="glyphicon glyphicon-remove"
                    onClick={() => {
                        this.changeType(null);
                    }}
                ></span>
            );

            style4.marginLeft = '1px';
        }

        return (
            <span style={style2}>
                {'Axis Type'}
                {clearElem}
                <div style={style4}>
                    <SelectField value={displayVal} options={types} onChange={this.changeType} />
                </div>
            </span>
        );
    }

    //LL: only for Y and A, if hasBubble.  Only numeric type, not Date
    getBubbleSizeFormat(value, ownKeys) {
        // let arr = ['default'];

        // if (typeof this.props.options?.getFormatFrontArray_Numeric_Func === 'function') {
        //     arr = this.props.options.getFormatFrontArray_Numeric_Func();
        // }
        const arr = ChartPropsManager.getFormatFrontArray_Numeric();

        let bubbleSizeFormatDefault = 'default';
        const options = makeListOptions(arr);

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'bubbleSizeFormat');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBubbleSizeFormatChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <select
                        ref={(input) => {
                            this.references.bubbleSizeFormat = input;
                        }}
                        className="form-control"
                        onChange={this.processBubbleSizeFormatChange}
                        value={value.bubbleSizeFormat || bubbleSizeFormatDefault}
                    >
                        {options}
                    </select>
                </div>
            </div>
        );
    }

    getBubbleSizePrecision_NumberField(value, ownKeys) {
        //   also depends on bubbleSizeFormat
        let lf = value.bubbleSizeFormat;
        let can = true;

        if (typeof this.props.options?.canAxisLabelPrecision_byLabelFormat_Func === 'function') {
            can = this.props.options.canAxisLabelPrecision_byLabelFormat_Func(lf);
        }

        if (!can) {
            return;
        }

        //LL: prohibit precision for currency, maybe temp, but now anyway precision is 2
        //    allowed in canAxisLabelPrecision_byLabelFormat_Func
        //if (lf === 'currency') return;

        let bubbleSizePrecisionDefault = 0;
        //let displayVal = value.bubbleSizePrecision || bubbleSizePrecisionDefault;
        //LL: was wrong when value.minValue == 0, because it is False, and then minValueDefault is used !
        let displayVal = value.bubbleSizePrecision;

        if (displayVal == null) {
            displayVal = bubbleSizePrecisionDefault;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'bubbleSizePrecision');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processBubbleSizePrecisionChange_NumberField); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberField
                        value={displayVal}
                        allowNull={false}
                        integer={true}
                        notNegative={true}
                        applyOnEnter={true}
                        onChange={this.processBubbleSizePrecisionChange_NumberField}
                    />
                </div>
            </div>
        );
    }

    getFontItalic(value, ownKeys) {
        let fontItalicDefault = false;
        let displayVal = value.fontItalic == null ? fontItalicDefault : value.fontItalic;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'fontItalic');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processFontItalicChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <input
                        ref={(input) => {
                            this.references.fontItalic = input;
                        }}
                        type="checkbox"
                        checked={displayVal}
                        onChange={this.processFontItalicChange}
                    />
                </div>
            </div>
        );
    }

    getFontFace(value, ownKeys) {
        let themeObj = this.props.themeObj;
        let fontFaceDefault = themeObj['widget-font']; // #font-main
        let axisFont = themeObj[themeFields.font_inAxisLabels];

        if (axisFont != null && axisFont.face != null) {
            fontFaceDefault = axisFont.face;
        }

        let displayVal = value.fontFace == null ? fontFaceDefault : value.fontFace;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'fontFace');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processFontFaceChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <FontField
                        value={displayVal}
                        theme={themeObj}
                        glob={this.props.glob}
                        onChange={this.processFontFaceChange}
                    />
                </div>
            </div>
        );
    }

    getFontSize(value, ownKeys) {
        const options_size = {
            values: [
                'default',
                'xx-small',
                'x-small',
                'small',
                'medium',
                'large',
                'x-large',
                'xx-large',
                'smaller',
                'larger'
            ],
            display: [
                'default',
                'xx-small',
                'x-small',
                'small',
                'medium',
                'large',
                'x-large',
                'xx-large',
                'smaller',
                'larger'
            ]
        };

        let themeObj = this.props.themeObj;
        let fontSizeDefault = themeObj['widget-font-size'];
        //let fontSizeDefault2 = themeObj[themeFields.font_inAxisLabels].size; // FontBoxField
        let axisFont = themeObj[themeFields.font_inAxisLabels];

        if (axisFont != null && axisFont.size != null) {
            fontSizeDefault = axisFont.size;
        }

        let displayVal = value.fontSize == null ? fontSizeDefault : value.fontSize;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'fontSize');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processFontSizeChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <SelectField value={displayVal} options={options_size} onChange={this.processFontSizeChange} />
                </div>
            </div>
        );
    }

    getFontWeight(value, ownKeys) {
        let options_weight = {
            values: ['lighter', 'normal', 'bold', 'bolder'],
            display: ['lighter', 'normal', 'bold', 'bolder']
        };

        let themeObj = this.props.themeObj;
        let fontWeightDefault = themeObj['widget-font-weight'];
        let axisFont = themeObj[themeFields.font_inAxisLabels];

        if (axisFont != null && axisFont.weight != null) {
            fontWeightDefault = axisFont.weight;
        }

        let displayVal = value.fontWeight == null ? fontWeightDefault : value.fontWeight;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'fontWeight');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processFontWeightChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <SelectField value={displayVal} options={options_weight} onChange={this.processFontWeightChange} />
                </div>
            </div>
        );
    }

    getLabelFormat(value, dataType: string, ownKeys) {
        //LL: commented, because LabelFormat is also can be used for formatting Point Labels and Tooltips,
        //    when "Format Config" field of configuration is not used
        if (
            dataType === ATTRIBUTE_TYPES.STRING ||
            dataType === ATTRIBUTE_TYPES.ENUMERATION ||
            dataType === ATTRIBUTE_TYPES.BOOLEAN
        ) {
            return <span className="form-control">{'default'}</span>;
        }

        let formatList; //LL: used when TimePart
        let arr = ['default'];

        if (dataType === ATTRIBUTE_TYPES.INTEGER || dataType === ATTRIBUTE_TYPES.REAL) {
            //     arr = this.props.options.getFormatFrontArray_Numeric_Func();
            arr = ChartPropsManager.getFormatFrontArray_Numeric();
        } else if (dataType === ATTRIBUTE_TYPES.DATETIME) {
            //     arr = this.props.options.getFormatFrontArray_DateTime_Func();
            arr = ChartPropsManager.getFormatFrontArray_DateTime();
        } else if (dataType === ATTRIBUTE_TYPES.DATE) {
            //     arr = this.props.options.getFormatFrontArray_Date_Func();
            arr = ChartPropsManager.getFormatFrontArray_Date();
        } else if (dataType === ATTRIBUTE_TYPES.TIME) {
            //     arr = this.props.options.getFormatFrontArray_Time_Func();
            arr = ChartPropsManager.getFormatFrontArray_Time();
        } else {
            // TimePart
            //arr = this.props.options.getFormatFrontArray_TimePart_Func(dataType);
            arr = ChartPropsManager.integer_TimePartFormats();
            formatList = arr.map((val) => {
                //LL: 'default' show as 'automatic':
                let txt = val === 'default' ? 'automatic' : val;

                return { value: val, name: txt, title: txt };
            });
        }

        //LL: formatting Integers as TimeParts
        if (dataType === ATTRIBUTE_TYPES.INTEGER) {
            const timePartsFormats = ChartPropsManager.integer_TimePartFormats();

            arr = arr.concat(timePartsFormats);
        }

        //LL: formatting as Time Interval:
        if (dataType === ATTRIBUTE_TYPES.INTEGER) {
            //const arrTimeIntervalFormats = this.props.options.getFormatFrontArray_TimeIntervals_Int_Func();
            const arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Int();

            arr = arr.concat(arrTimeIntervalFormats);
        }

        if (dataType === ATTRIBUTE_TYPES.REAL) {
            //const arrTimeIntervalFormats = this.props.options.getFormatFrontArray_TimeIntervals_Real_Func();
            const arrTimeIntervalFormats = ChartPropsManager.getFormatFrontArray_TimeIntervals_Real();

            arr = arr.concat(arrTimeIntervalFormats);
        }

        let labelFormatDefault = 'default';
        let displayVal = value.labelFormat || labelFormatDefault;
        let options: React.JSX.Element[];

        if (formatList == null) {
            options = _.map(arr, (val, index) => {
                //LL: 'default' show as 'automatic':
                let txt = val === 'default' ? 'automatic' : val;

                return (
                    <option key={val + '_' + index} value={val}>
                        {txt}
                    </option>
                );
            });
        } else {
            options = _.map(formatList, (obj, index) => {
                return (
                    <option key={obj.name + '_' + index} value={obj.value} title={obj.title}>
                        {obj.name}
                    </option>
                );
            });
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        const ownKey = this.isOwnKey(ownKeys, 'labelFormat');

        let clearElement: React.JSX.Element;

        if (ownKey) {
            clearElement = this.createClearOwnElement(this.processLabelFormatChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElement}
                <div className="own-value">
                    <select
                        ref={(input) => {
                            this.references.labelFormat = input;
                        }}
                        className="form-control"
                        value={displayVal}
                        onChange={this.processLabelFormatChange}
                    >
                        {options}
                    </select>
                </div>
            </div>
        );
    }

    getCustomFormat(value, ownKeys) {
        let customFormatDefault = '';
        let displayVal = value.customFormat || customFormatDefault;
        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'customFormat');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processCustomFormatChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <StringField
                        value={displayVal}
                        applyOnEnter={true}
                        changeOnBlurOnly={true}
                        onChange={this.processCustomFormatChange}
                    />
                </div>
            </div>
        );
    }

    //LL: local currency, when labelFormat = "currency"
    getLabelCurrency(value, dataType, ownKeys) {
        if (!(dataType === 'i' || dataType === 'r')) {
            return;
        }
        if (value.labelFormat !== 'currency') {
            return;
        }

        let labelCurrencyDefault;

        //  see in FormatChooser  //here default currency from Theme  this.props.themeObj
        let displayValue =
            value.labelCurrency || labelCurrencyDefault || this.props.themeObj[themeVars.currencySelector];

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'labelCurrency');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processLabelCurrencyChange); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <StringField
                        value={displayValue}
                        applyOnEnter={true}
                        changeOnBlurOnly={true}
                        onChange={this.processLabelCurrencyChange}
                    />
                </div>
            </div>
        );
    }

    getLabelPrecision_NumberField(value, dataType, ownKeys) {
        //LL: hidden when data type != numeric or datetime
        //   also depends on ShowLabel and LabelFormat

        //LL: commented, because LabelFormat is also can be used for formatting Point Labels and Tooltips,
        //    when "Format Config" field of configuration is not used
        //if (value.showLabels === false) return;

        if (!(dataType === 'i' || dataType === 'r')) {
            return;
        }

        let lf = value.labelFormat;
        let can = true;

        if (
            this.props.options != null &&
            typeof this.props.options.canAxisLabelPrecision_byLabelFormat_Func === 'function'
        ) {
            can = this.props.options.canAxisLabelPrecision_byLabelFormat_Func(lf);
        }

        if (!can) {
            return;
        }

        let labelPrecisionDefault = 0;
        let displayVal = value.labelPrecision || labelPrecisionDefault;
        //let displayVal = value.labelPrecision;

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'labelPrecision');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.processLabelPrecisionChange_NumberField); // className="clear-button"
        }

        return (
            <div className="inheritedValue">
                {clearElem}
                <div className="own-value">
                    <NumberSpinnerExtended
                        value={displayVal}
                        integer={true}
                        min={0}
                        onChange={this.processLabelPrecisionChange_NumberField}
                    />
                </div>
            </div>
        );
    }

    getMinValue_allowNull(value, dataType, fullStackedOnAxis, ownKeys) {
        //LL: hidden when data type != numeric or datetime
        //LL:  numeric (int or real) or date - depends on DataType.

        let minValueDefault;

        //let displayVal = value.minValue || minValueDefault;   //LL:  may be null
        //LL: was wrong when value.minValue == 0, because it is False, and then minValueDefault is used !
        let displayVal = value.minValue;
        if (displayVal == null) {
            displayVal = minValueDefault;
        }

        if (dataType === 'i' && fullStackedOnAxis) {
            dataType = 'r';
        }

        let hint = '';

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'minValue');
        let clearElem;

        switch (dataType) {
            case 'i':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMinValueChange_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={true}
                                applyOnEnter={true}
                                onChange={this.processMinValueChange_N}
                            />
                        </div>
                    </div>
                );

            case 'r':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMinValueChange_Float); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={false}
                                applyOnEnter={true}
                                onChange={this.processMinValueChange_Float}
                            />
                        </div>
                    </div>
                );

            case 'datetime':
            case 'date':
                //LL:  minValue may be null
                //displayVal = value.minValue || Date.now();

                hint = displayVal == null ? 'not set, default' : displayVal.toString();

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMinValueChange_Date_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                value={displayVal}
                                allowNull={true}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processMinValueChange_Date_N}
                            />
                        </div>
                    </div>
                );

            case 'time':
                let displayValSav = displayVal;

                //LL:  minValue may be null
                //displayVal = value.minValue;
                if (displayVal != null) {
                    displayVal = DateTimeFunctions.convertTimeStringToDate(displayVal);

                    if (displayVal != null) {
                        // is 02.01.1970
                        displayVal.setYear(DateTimeFunctions.TimeDefaultDate.year);
                        displayVal.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                        displayVal.setDate(DateTimeFunctions.TimeDefaultDate.day);
                    }
                }

                //LL: for "time": val = "1899-12-31T02:30:00"
                //    so raw:'HH:mm:ss' is wrong, hint is empty !!
                //LL:  see in IntervalsSelect.tsx and Utilities
                //   function convertTimeValueAsDateToString(dateString: string)
                //   const TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss';
                //   const TimeDisplayFormat = 'HH:mm:ss';
                //   const TimeDisplayFormatShort = 'HH:mm';

                hint =
                    displayValSav == null
                        ? 'not set, default'
                        : DateTimeFunctions.convertTimeValueAsDateToString(displayValSav);
                //hint = (displayValSav == null ? "not set, default" : DateTimeFunctions.convertTimeValueAsDateToString_Short(displayValSav));

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMinValueChange_Date_N); // className="clear-button"
                }

                //LL: 09.11.18: in DateField.tsx change in normalizeValue by RYB on 31.10.18 and it breaks my Chart code for "time"
                //LL: 09.11.18: to avoid it, introduce option "formattedTime = true"
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                type={'time'}
                                displayDateTimeFormat={'HH:mm:ss'}
                                value={displayVal}
                                allowNull={true}
                                options={{ formattedTime: true, nullSeconds: true }}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processMinValueChange_Date_N}
                            />
                        </div>
                    </div>
                );

            default:
                return;
        }
    }

    getMaxValue_allowNull(value, dataType, fullStackedOnAxis, ownKeys) {
        //LL: hidden when data type != numeric or datetime
        //LL:  numeric (int or real) or date - depends on DataType.

        let maxValueDefault;

        //LL: was wrong when value.minValue == 0, because it is False, and then minValueDefault is used !
        let displayVal = value.maxValue;
        if (displayVal == null) {
            displayVal = maxValueDefault;
        }

        if (dataType === 'i' && fullStackedOnAxis) {
            dataType = 'r';
        }

        let hint = '';

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey = this.isOwnKey(ownKeys, 'maxValue');
        let clearElem;

        switch (dataType) {
            case 'i':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMaxValueChange_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={true}
                                applyOnEnter={true}
                                onChange={this.processMaxValueChange_N}
                            />
                        </div>
                    </div>
                );

            case 'r':
                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMaxValueChange_Float); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <NumberField
                                value={displayVal}
                                allowNull={true}
                                integer={false}
                                applyOnEnter={true}
                                onChange={this.processMaxValueChange_Float}
                            />
                        </div>
                    </div>
                );

            case 'datetime':
            case 'date':
                //LL:  maxValue may be null
                //displayVal = value.maxValue || Date.now();
                // hideClearButton={ true }

                hint = displayVal == null ? 'not set, default' : displayVal.toString();

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMaxValueChange_Date_N); // className="clear-button"
                }
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                value={displayVal}
                                allowNull={true}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processMaxValueChange_Date_N}
                            />
                        </div>
                    </div>
                );

            case 'time':
                //LL:  maxValue may be null

                let displayValSav = displayVal;

                //displayVal = value.maxValue;
                if (displayVal != null) {
                    displayVal = DateTimeFunctions.convertTimeStringToDate(displayVal);
                    if (displayVal != null) {
                        // is 02.01.1970
                        displayVal.setYear(DateTimeFunctions.TimeDefaultDate.year);
                        displayVal.setMonth(DateTimeFunctions.TimeDefaultDate.month - 1);
                        displayVal.setDate(DateTimeFunctions.TimeDefaultDate.day);
                    }
                }

                //LL: for "time": val = "1899-12-31T02:30:00"
                //    so raw:'HH:mm:ss' is wrong, hint is empty !!
                //LL:  see in IntervalsSelect.tsx and Utilities
                //   function convertTimeValueAsDateToString(dateString: string)
                //   const TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss';
                //   const TimeDisplayFormat = 'HH:mm:ss';
                //   const TimeDisplayFormatShort = 'HH:mm';
                hint =
                    displayValSav == null
                        ? 'not set, default'
                        : DateTimeFunctions.convertTimeValueAsDateToString(displayValSav);

                if (ownKey) {
                    clearElem = this.createClearOwnElement(this.processMaxValueChange_Date_N); // className="clear-button"
                }

                //LL: 09.11.18: in DateField.tsx change in normalizeValue by RYB on 31.10.18 and it breaks my Chart code for "time"
                //LL: 09.11.18: to avoid it, introduce option "formattedTime = true"
                return (
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <DateField
                                type={'time'}
                                displayDateTimeFormat={'HH:mm:ss'}
                                value={displayVal}
                                allowNull={true}
                                options={{ formattedTime: true, nullSeconds: true }}
                                hideClearButton={false}
                                hint={hint}
                                onChange={this.processMaxValueChange_Date_N}
                            />
                        </div>
                    </div>
                );

            default:
                return;
        }
    }

    _get_rotated() {
        let rotated = false;
        if (this.props.themeObj != null && this.props.themeObj[themeFields.axis_rotateXY] != null) {
            rotated = this.props.themeObj[themeFields.axis_rotateXY];
        }
        return rotated;
    }

    _get_synchronizeMultiAxes() {
        let synchronizeMultiAxes = true; // default
        if (this.props.themeObj != null && this.props.themeObj[themeFields.axis_synchronizeMultiAxes] != null) {
            synchronizeMultiAxes = this.props.themeObj[themeFields.axis_synchronizeMultiAxes];
        }
        return synchronizeMultiAxes;
    }

    get_props_values() {
        let pv;

        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-chart') {
                pv = this.props.options.widgetValues;
            }
        }
        return pv;
    }

    _get_dataType(kind) {
        const { options } = this.props;

        let dataType = 's';
        let props_values = this.get_props_values();

        if (props_values == null) {
            return dataType;
        }

        let dType;

        if (kind === 'x' || kind === 'X') {
            if (props_values != null && typeof options?.getDataType_Func === 'function') {
                dType = options.getDataType_Func(props_values, this.props.glob);
            }
        } else if (kind === 'y' || kind === 'Y') {
            if (props_values != null && typeof options?.getDataType_Func === 'function') {
                dType = options.getDataType_Func(props_values, this.props.glob);
            }
        } else if (kind === 'a' || kind === 'A') {
            if (props_values != null && typeof options?.getDataType_Func === 'function') {
                //dType = options.getDataType_Func(props_values, options.name, this.props.themeObj);
                dType = options.getDataType_Func(props_values, this.props.glob);
            }
        }

        if (dType != null) {
            dataType = dType;
        }

        return dataType;
    }

    _is_fullStackedOnAxis(kind) {
        let props_values = this.get_props_values();
        if (props_values == null) {
            //props_values = {};
        }

        let fullStackedOnAxis = false;
        if (kind === 'x' || kind === 'X') {
            // not used for 'x'
        } else if (kind === 'y' || kind === 'Y') {
            if (
                props_values != null &&
                this.props.options != null &&
                typeof this.props.options.is_fullStackedOnAxis_Func === 'function'
            ) {
                fullStackedOnAxis = this.props.options.is_fullStackedOnAxis_Func(this.props.themeObj, props_values);
            }
        }
        //LL: not implem:
        else if (kind === 'a' || kind === 'A') {
            if (
                props_values != null &&
                this.props.options != null &&
                typeof this.props.options.is_fullStackedOnAxis_Func === 'function'
            ) {
                fullStackedOnAxis = this.props.options.is_fullStackedOnAxis_Func(
                    this.props.themeObj,
                    props_values,
                    this.props.options.name
                );
            }
        }
        return fullStackedOnAxis;
    }

    _get_dataTypeText(dataType) {
        switch (dataType) {
            case 'i':
            case 'r':
            case 'datetime':
            case 'date':
            case 'time':
            case 's':
            case 'e':
            case 'b':
            case 'string':
            case 'undefined':
            case 'number':
            case 'integer':
            case 'real':
                return dataType;
            default:
                return 'TimePart ' + dataType;
        }
    }

    handleOnRemoveClick = () => {
        if (typeof this.props.options.onRemove === 'function') {
            this.props.options.onRemove(this.props.options.name); //  == axis name
        }
    };

    getRemoveButton(useRemove, canRemove, useInheritedButton) {
        //LL: for AUX: new useInheritedButton:
        if (useInheritedButton === true) {
            let style2 = { cursor: 'default' };
            return <span className="glyphicon glyphicon-arrow-down" style={style2} title="inherited"></span>;
        }

        if (!useRemove) {
            return;
        }

        if (canRemove) {
            return (
                <span
                    className="glyphicon glyphicon-remove"
                    title="Remove this Axis"
                    onClick={this.handleOnRemoveClick}
                ></span>
            );
        } else {
            let style2 = { color: '#d3d3d3', cursor: 'default' };
            //  React.createElement("div", {className: "cell-remove", style: style2 },
            //  <div className="cell-remove"  style={ style2 }>

            return (
                <span
                    className="glyphicon glyphicon-remove-sign"
                    style={style2}
                    title="Cannot remove this Axis, used in Data Queries"
                ></span>
            );
        }
    }

    processApplyPredefinedAxis = (e) => {
        e.stopPropagation();
        e.preventDefault();

        let selectedPredefinedAxis = this.state.selectedPredefinedAxis; //LL:   may be '', null

        if (selectedPredefinedAxis == null || selectedPredefinedAxis === '') return;

        let themeFieldForAxisList = this.props.options.themeFieldForAxisList;
        let themeObj = this.props.themeObj;

        if (themeFieldForAxisList != null && themeObj != null) {
            let axisList = themeObj[themeFieldForAxisList];

            if (axisList != null && axisList.length > 0) {
                let axisObj = _.find(axisList, function (obj) {
                    return obj.name === selectedPredefinedAxis;
                });

                if (axisObj != null) {
                    let obj = _.clone(this.props.value || {});

                    axisObj = $.extend(true, {}, axisObj); // copy
                    //  name, inherited - to remove them;   dataType -> dataTypePredefined
                    delete axisObj.inherited;
                    delete axisObj.name;
                    delete axisObj.dataType;

                    // position:  see in ChartAxisListField:
                    //    let a = ['bottom', 'top'];
                    //    let d = ['bottom/left', 'top/right'];
                    //  So, change for Value axis:
                    let kind = 'x';
                    if (this.props.options != null && this.props.options.kind != null) {
                        kind = this.props.options.kind;
                    }
                    if (!(kind === 'x' || kind === 'X')) {
                        if (axisObj.position === 'top') axisObj.position = 'right';
                        else if (axisObj.position === 'bottom') axisObj.position = 'left';
                    }

                    obj = $.extend(true, obj, axisObj);

                    //LL: see in main:
                    //newObj.visible = obj.show;
                    ////delete newObj.show;
                    ////LL: without delete:
                    //newObj.labelsVisible = obj.showLabels;
                    //newObj.labelsFormat = obj.labelFormat;
                    //newObj.labelsCurrency = obj.labelCurrency;
                    //newObj.customFormat = obj.customFormat;
                    //newObj.labelsPrecision = obj.labelPrecision;
                    //newObj.labelsHasCustomFormat = obj.labelHasCustomFormat;

                    if (axisObj.show != null) obj.visible = axisObj.show;
                    //delete axisObjNew.show;
                    if (axisObj.showLabels != null) obj.labelsVisible = axisObj.showLabels;
                    if (axisObj.labelFormat != null) obj.labelsFormat = axisObj.labelFormat;
                    if (axisObj.labelCurrency != null) obj.labelsCurrency = axisObj.labelCurrency;
                    if (axisObj.customFormat != null) obj.customFormat = axisObj.customFormat;
                    if (axisObj.labelPrecision != null) obj.labelsPrecision = axisObj.labelPrecision;
                    if (axisObj.labelHasCustomFormat != null) obj.labelsHasCustomFormat = axisObj.labelHasCustomFormat;
                    //delete axisObjNew.showLabels;
                    //delete axisObjNew.labelFormat;
                    //delete axisObjNew.labelCurrency;
                    //delete axisObjNew.customFormat;
                    //delete axisObjNew.labelPrecision;
                    //delete axisObjNew.labelHasCustomFormat;

                    this.handleValueChange(obj);
                }
            }
        }
    };

    processAxisChange = (e) => {
        let val = (this.references.selectAxis as HTMLInputElement).value;

        this.setState(
            _.extend(this.state, {
                selectedPredefinedAxis: val
            })
        );
    };

    processPredefinedDataTypeChange = (e) => {
        let val = (this.references.selectPredefinedDataType as HTMLInputElement).value;

        if (val === '') {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.inheritedPredefinedDataType;
        } else {
            obj.inheritedPredefinedDataType = val;
        }
        this.handleValueChange(obj);
    };

    areCompatible(dt1, dt2) {
        //  dt1 - dataType from Predefined AxisList
        //  dt2 - actual calculated for Axis
        switch (dt1) {
            case chartConstants.dataTypes.undefDataType:
            case 'string':
            case 's':
                return true;
            case 'integer':
            case 'i':
                return dt2 === 'i' || dt2 === 'integer';
            case 'real':
            case 'r':
                return dt2 === 'r' || dt2 === 'real';
            case 'datetime':
            case 'date':
                return dt2 === dt1;
            case 'time':
                return dt2 === 'time';
            default:
                // timeParts, for example
                return dt2 === dt1;
        }
        //return false;
    }

    render() {
        //LL: for 'X' and 'Y' kind:  ability to APPLY predefined axis values
        let predefinedDataTypeElem; //LL: when with standard inheritance, on upper levels
        let compatibilityErrorElem;
        let forActualChart = true; //LL: false when with standard inheritance, on upper levels
        let props_values = this.get_props_values();

        if (props_values == null) {
            forActualChart = false; //LL: when with standard inheritance, on upper levels
        }

        //LL: ownKeys - props with these keys will have glyphicon-remove
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentValues_forObjects(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;
        //LL: this is new for object-fields:
        let keysArr = _.keys(ownValues); // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]
        let ownKeys = [];

        _.each(keysArr, (obj) => {
            if (parentValues[obj] == null || parentValues[obj] !== ownValues[obj]) {
                ownKeys.push(obj);
            }
        });

        let kind = 'x';

        if (this.props.options != null && this.props.options.kind != null) {
            kind = this.props.options.kind;
        }

        let multiAxis = true;

        if (kind === 'a' || kind === 'A') {
            multiAxis = true;
        } else {
            if (
                props_values != null &&
                this.props.options != null &&
                typeof this.props.options.isMultiValueAxis_Func === 'function'
            ) {
                multiAxis = this.props.options.isMultiValueAxis_Func(props_values, this.props.themeObj);
            }
        }

        let value = this.props.value || {};
        let name_Value;

        if (this.props.options != null && this.props.options.name != null) {
            name_Value = this.props.options.name;
        }

        if (name_Value == null) {
            if (kind === 'x' || kind === 'X') {
                name_Value = 'Arguments';
            } else if (kind === 'y' || kind === 'Y') {
                name_Value = 'Values';
            } else {
                name_Value = 'AUX1';
            }
        }

        let dataTypeExt: any = this._get_dataType(kind);
        let dataType;
        let dataTypePure;
        let dataTimePart;

        if (typeof dataTypeExt === 'string') {
            // very old,  but can be if it is default "s"
            dataType = dataTypeExt;
            dataTypePure = dataTypeExt;
            dataTimePart = dataTypeExt;
        } else {
            // new  now for X
            dataType = dataTypeExt.type;
            if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
                dataType = dataTypeExt.timePart;
            }
            dataTypePure = dataTypeExt.type;
            dataTimePart = dataTypeExt.timePart;
        }

        let isAssignedSecondaryAxis; // = false;

        if (forActualChart) {
            if (kind === 'a' || kind === 'A') {
                if (
                    props_values != null &&
                    this.props.options != null &&
                    typeof this.props.options.isAssignedSecondaryAxis_Func === 'function'
                ) {
                    isAssignedSecondaryAxis = this.props.options.isAssignedSecondaryAxis_Func(
                        props_values,
                        this.props.options.name
                    );
                }
            }
        }

        let dataTypeValue = this._get_dataTypeText(dataType);
        if (isAssignedSecondaryAxis === false) {
            dataTypeValue = 'not assigned';
        }

        let dataTypeStr = (
            <React.Fragment>
                {'Data Type: '}
                <strong>
                    <em>{dataTypeValue}</em>
                </strong>
            </React.Fragment>
        );

        //LL: display either dataTypeStr or dataTypePredefinedStr, when canRemove
        let showPredefinedDataType = false;
        //LL: for 'A' kind only:
        let dataTypePredefined = value.dataTypePredefined;
        let dataTypePredefinedStr;

        if (dataTypePredefined != null) {
            dataTypePredefinedStr = (
                <React.Fragment>
                    {'Predefined Data Type: '}
                    <strong>
                        <em>{dataTypePredefined}</em>
                    </strong>
                </React.Fragment>
            );

            //LL: presume Predefined is always of kind = 'a'
            //LL: canRemove when Axis is not assigned, so dataType is actually undefined
            let canRemove = true;

            if (this.props.options.canRemove != null) {
                canRemove = this.props.options.canRemove;
            }

            if (canRemove) {
                //LL: canRemove when Axis is not assigned, so dataType is actually undefined
                showPredefinedDataType = true;

                dataType = dataTypePredefined;
                dataTypePure = dataTypePredefined;

                let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataType);

                if (isTimePart) {
                    dataTypePure = 'i';
                    dataTimePart = dataTypePredefined;
                } else {
                    dataTimePart = null;
                    switch (dataTypePredefined) {
                        case 'integer':
                            dataType = 'i';
                            dataTypePure = 'i';
                            break;
                        case 'real':
                            dataType = 'r';
                            dataTypePure = 'r';
                            break;
                        case 'string':
                        case chartConstants.dataTypes.undefDataType:
                            dataType = 's';
                            dataTypePure = 's';
                            break;
                    }
                }
            }
        }

        //LL: dataType_current instead of dataType   also for dataTypePure, dataTimePart
        //LL: when with standard inheritance, on upper levels (dataType is not defined)
        let dataType_current = dataType;
        let dataTypePure_current = dataTypePure;
        let dataTimePart_current = dataTimePart;

        if (!forActualChart) {
            let inheritedPredefinedDataType = value.inheritedPredefinedDataType || undefDataType;

            dataType_current = inheritedPredefinedDataType;
            dataTypePure_current = inheritedPredefinedDataType;

            let isTimePart = _.contains(chartConstants.dataTypes.arrTimePartTypes, dataType_current);

            if (isTimePart) {
                dataTypePure_current = 'i';
                dataTimePart_current = inheritedPredefinedDataType;
            } else {
                dataTimePart_current = null;
                switch (inheritedPredefinedDataType) {
                    case 'integer':
                        dataType_current = 'i';
                        dataTypePure_current = 'i';
                        break;
                    case 'real':
                        dataType_current = 'r';
                        dataTypePure_current = 'r';
                        break;
                    case 'string':
                    case chartConstants.dataTypes.undefDataType:
                        dataType_current = 's';
                        dataTypePure_current = 's';
                        break;
                }
            }
        }

        //LL: dataType_current instead of dataType   also for dataTypePure, dataTimePart
        let applyFromPredefinedElem_inFooter: React.JSX.Element;

        if (kind === 'x' || kind === 'X' || kind === 'y' || kind === 'Y') {
            let themeFieldForAxisList = this.props.options.themeFieldForAxisList;
            let themeObj = this.props.themeObj;

            if (themeFieldForAxisList != null && themeObj != null) {
                let axisList = themeObj[themeFieldForAxisList];

                if (axisList != null && axisList.length > 0) {
                    //LL: must be only of the compatible data type !!
                    let axisListReduced = _.filter(axisList, (axisObj) => {
                        return this.areCompatible(axisObj.dataType, dataType);
                    });

                    if (axisListReduced != null && axisListReduced.length > 0) {
                        let applyPredefinedButtonVal = (
                            <em className="empty btn btn-default" onClick={this.processApplyPredefinedAxis}>
                                {'Apply from Predefined:'}
                            </em>
                        );

                        let options = _.map(axisListReduced, (item, index) => {
                            return (
                                <option key={item.name + '_' + index} value={item.name}>
                                    {item.name + ' (' + item.dataType + ')'}
                                </option>
                            );
                        });

                        // Warning: `value` prop on `select` should not be null.
                        // Consider using an empty string to clear the component or `undefined` for uncontrolled components.
                        let axisVal = this.state.selectedPredefinedAxis || '';

                        if (this.state.selectedPredefinedAxis == null) {
                            options.unshift(
                                <option key={'choose-an-item'} value={''} disabled={true}>
                                    {'choose an item'}
                                </option>
                            );
                        }

                        //LL: in single line
                        applyFromPredefinedElem_inFooter = (
                            <div className="entity-select apply-axis-inFooter">
                                <div className="content apply-predefined-button-inFooter">
                                    <span className="value">{applyPredefinedButtonVal}</span>
                                </div>
                                <div className="select-axis-inFooter">
                                    <select
                                        ref={(input) => {
                                            this.references.selectAxis = input;
                                        }}
                                        className="form-control"
                                        onChange={this.processAxisChange}
                                        value={axisVal}
                                    >
                                        {options}
                                    </select>
                                </div>
                            </div>
                        );
                    } // axisListReduced
                } //  axisList
            }
        }

        if (!forActualChart) {
            applyFromPredefinedElem_inFooter = null;
        }
        //LL: or for all levels:
        applyFromPredefinedElem_inFooter = null;

        if (forActualChart) {
            let dataTypeVal = value.inheritedPredefinedDataType || undefDataType;
            //LL: don't show when undef
            if (dataTypeVal !== undefDataType) {
                dataTypeValue = this._get_dataTypeText(dataTypeVal);
                predefinedDataTypeElem = (
                    <React.Fragment>
                        {'Predefined Inherited Data Type: '}{' '}
                        <strong>
                            <em>{dataTypeValue}</em>
                        </strong>
                    </React.Fragment>
                );

                let compatible = this.areCompatible(dataTypeVal, dataType);
                //LL: for not assigned AUX axis: always compatible
                if (isAssignedSecondaryAxis === false) {
                    //  see dataTypeValue = "not assigned";
                    compatible = true;
                }

                if (!compatible) {
                    compatibilityErrorElem = (
                        <div style={{ color: 'red', marginBottom: '8px' }}>
                            Actual Data Type and Predefined Data Type are incompatible. Inherited Options depending on
                            Data Type are ignored.
                        </div>
                    );
                }
            }
        } else {
            // - choose Data Type:
            let arrDataTypes = [];
            arrDataTypes.push(undefDataType);
            Array.prototype.push.apply(arrDataTypes, arrCommonDataTypes);
            Array.prototype.push.apply(arrDataTypes, arrTimePartTypes);

            let dataTypeVal = value.inheritedPredefinedDataType || undefDataType; // this.defaultDataType;
            const options = makeListOptions(arrDataTypes);

            predefinedDataTypeElem = (
                <div style={{ display: 'inline-block' }}>
                    {'Select predefined Data Type:'}
                    <div
                        style={{
                            display: 'inline-block',
                            marginLeft: '4px'
                        }}
                    >
                        <select
                            ref={(input) => {
                                this.references.selectPredefinedDataType = input;
                            }}
                            className="form-control"
                            value={dataTypeVal}
                            onChange={this.processPredefinedDataTypeChange}
                        >
                            {options}
                        </select>
                    </div>
                </div>
            );
        }

        // - row0:
        // - show   Show Axis
        let show_Value = value.show;

        if (show_Value == null) {
            show_Value = true;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_show = this.isOwnKey(ownKeys, 'show');
        let clearElem_show;

        if (ownKey_show) {
            clearElem_show = this.createClearOwnElement_Bool(this.changeShow);
        }

        let show_Class = 'col-sm-2';
        let show_Elem = (
            <div className={show_Class}>
                {clearElem_show}
                <div className="inlineBlock">
                    <BooleanField value={show_Value} title={'Show Axis'} onChange={this.changeShow} />
                </div>
            </div>
        );

        // - showLine
        let showLine_Value = value.showLine;
        let showLine_Value_default;

        if (kind === 'x' || kind === 'X') {
            showLine_Value_default = false;
        } else if (kind === 'y' || kind === 'Y') {
            showLine_Value_default = false;
        } else {
            showLine_Value_default = true;
        }

        if (showLine_Value == null) {
            //LL: default DevExpr - false, default for my AUX - true (in ..._parametrized)
            showLine_Value = showLine_Value_default;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showLine = this.isOwnKey(ownKeys, 'showLine');
        let clearElem_showLine;

        if (ownKey_showLine) {
            clearElem_showLine = this.createClearOwnElement_Bool(this.changeShowLine);
        }

        const showLine_Elem = (
            <div className="col-sm-2">
                {clearElem_showLine}
                <div className="inlineBlock">
                    <BooleanField value={showLine_Value} title={'Show Line'} onChange={this.changeShowLine} />
                </div>
            </div>
        );

        // - showGridLines
        let showGridLines_Value = value.showGridLines;

        if (showGridLines_Value == null) {
            //LL: default DevExpr - false, default for my AUX - false, X - false, Y - true (in ..._parametrized)
            let showGridLines_Value_default;
            if (kind === 'x' || kind === 'X') {
                showGridLines_Value_default = false;
            } else if (kind === 'y' || kind === 'Y') {
                showGridLines_Value_default = true;
            } else {
                showGridLines_Value_default = false;
            }
            showGridLines_Value = showGridLines_Value_default;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showGridLines = this.isOwnKey(ownKeys, 'showGridLines');
        let clearElem_showGridLines;

        if (ownKey_showGridLines) {
            clearElem_showGridLines = this.createClearOwnElement_Bool(this.changeShowGridLines);
        }

        const showGridLines_Elem = (
            <div className="col-sm-3">
                {clearElem_showGridLines}
                <div className="inlineBlock">
                    <BooleanField
                        value={showGridLines_Value}
                        title={'Show Grid Lines'}
                        onChange={this.changeShowGridLines}
                    />
                </div>
            </div>
        );

        // - showAxisTicks
        let showAxisTicks_Value = value.showAxisTicks;

        if (showAxisTicks_Value == null) {
            showAxisTicks_Value = false;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showAxisTicks = this.isOwnKey(ownKeys, 'showAxisTicks');
        let clearElem_showAxisTicks;

        if (ownKey_showAxisTicks) {
            clearElem_showAxisTicks = this.createClearOwnElement_Bool(this.changeShowAxisTicks);
        }

        const showAxisTicks_Elem = (
            <div className="col-sm-3">
                {clearElem_showAxisTicks}
                <div className="inlineBlock">
                    <BooleanField
                        value={showAxisTicks_Value}
                        title={'Show Ticks'}
                        onChange={this.changeShowAxisTicks}
                    />
                </div>
            </div>
        );

        // - showMinorTicks
        //LL: hidden when type = discrete or automatic-discrete
        let showMinorTicks_Value = value.showMinorTicks;

        if (showMinorTicks_Value == null) {
            showMinorTicks_Value = false;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showMinorTicks = this.isOwnKey(ownKeys, 'showMinorTicks');
        let clearElem_showMinorTicks;

        if (ownKey_showMinorTicks) {
            clearElem_showMinorTicks = this.createClearOwnElement_Bool(this.changeShowMinorTicks);
        }

        let showMinorTicks_Elem;

        if (showAxisTicks_Value === true) {
            showMinorTicks_Elem = (
                <div className="col-sm-3">
                    {clearElem_showMinorTicks}
                    <div className="inlineBlock">
                        <BooleanField
                            value={showMinorTicks_Value}
                            title={'Show Minor Ticks'}
                            onChange={this.changeShowMinorTicks}
                        />
                    </div>
                </div>
            );
        }

        // - showMinorGridLines
        //LL: hidden when type = discrete or automatic-discrete
        let showMinorGridLines_Value = value.showMinorGridLines;

        if (showMinorGridLines_Value == null) {
            showMinorGridLines_Value = false;
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showMinorGridLines = this.isOwnKey(ownKeys, 'showMinorGridLines');
        let clearElem_showMinorGridLines;

        if (ownKey_showMinorGridLines) {
            clearElem_showMinorGridLines = this.createClearOwnElement_Bool(this.changeShowMinorGridLines);
        }

        let showMinorGridLines_Elem;

        if (showGridLines_Value === true) {
            showMinorGridLines_Elem = (
                <div className="col-sm-3">
                    {clearElem_showMinorGridLines}
                    <div className="inlineBlock">
                        <BooleanField
                            value={showMinorGridLines_Value}
                            title={'Show Minor Grid Lines'}
                            onChange={this.changeShowMinorGridLines}
                        />
                    </div>
                </div>
            );
        }

        // - showLabels
        let showLabels_Value = value.showLabels;

        if (showLabels_Value == null) {
            showLabels_Value = true;
            // obj.labelsVisible = axisObj.showLabels;  ???  no
        }

        //LL: ownKeys - props with these keys are not inherited, will have glyphicon-remove
        let ownKey_showLabels = this.isOwnKey(ownKeys, 'showLabels');
        let clearElem_showLabels: React.JSX.Element;

        if (ownKey_showLabels) {
            clearElem_showLabels = this.createClearOwnElement_Bool(this.changeShowLabels);
        }

        const showLabels_Elem = (
            <div className="col-sm-2">
                {clearElem_showLabels}
                <div className="inlineBlock">
                    <BooleanField value={showLabels_Value} title={'Show Labels'} onChange={this.changeShowLabels} />
                </div>
            </div>
        );

        let rotated = this._get_rotated();
        let synchronizeMultiAxes = this._get_synchronizeMultiAxes();
        let fullStackedOnAxis = this._is_fullStackedOnAxis(kind);
        // class "table" has margin-bottom:1rem,  16px

        let styleRow1 = { marginTop: '0.5rem', marginBottom: '0.5rem' };
        let axisType_Elem = <div className="col-sm-4">{this.getTypeInRow0(value, kind, ownKeys, !forActualChart)}</div>;
        let styleRow0: React.CSSProperties = { marginBottom: 12 };
        let styleRow01: React.CSSProperties = { marginBottom: 10 };
        let thColorSeries;
        let tdColorSeries;

        if (kind === 'a' || kind === 'A') {
            thColorSeries = <th className="cell-colorSeries">{'Series Color'}</th>;
            tdColorSeries = <td className="cell-colorSeries">{this.getColorSeries(value, ownKeys)}</td>;
        }

        //LL: dataType_current instead of dataType   also for dataTypePure, dataTimePart
        //   Applies only to the axes of the "continuous" and "logarithmic" types.
        // let thMaxMargin;
        // let tdMaxMargin;
        // let thMinMargin;
        // let tdMinMargin;
        //LL: "Top Margin", "Bottom Margin": hint "0-100: percent of Data Values Range (leave empty for automatic)":
        let thTopMargin;
        let tdTopMargin;
        let thBottomMargin;
        let tdBottomMargin;
        //LL: hidden when type = discrete or automatic-discrete
        if (
            ((dataTypePure_current === 'i' || dataTypePure_current === 'r') && value.type !== 'discrete') ||
            ((dataTypePure_current === 'datetime' ||
                dataTypePure_current === 'date' ||
                dataTypePure_current === 'time') &&
                value.type === 'continuous')
        ) {
            // thMaxMargin = (
            //     <th className="cell-width" title="Max Value Margin 0-1 (leave empty for automatic)">
            //         {'Max Margin'}
            //     </th>
            // );
            // tdMaxMargin = <td className="cell-width">{this.getMaxMargin(value, ownKeys)}</td>;
            // thMinMargin = (
            //     <th className="cell-width" title="Min Value Margin 0-1 (leave empty for automatic)">
            //         {'Min Margin'}
            //     </th>
            // );
            // tdMinMargin = <td className="cell-width">{this.getMinMargin(value, ownKeys)}</td>;
            thTopMargin = (
                <th className="cell-width" title="0-100: percent of Data Values Range (leave empty for automatic)">
                    {'Top Margin(%)'}
                </th>
            );
            tdTopMargin = <td className="cell-width">{this.getTopMargin(value, ownKeys)}</td>;
            thBottomMargin = (
                <th className="cell-width" title="0-100: percent of Data Values Range (leave empty for automatic)">
                    {'Bottom Margin(%)'}
                </th>
            );
            tdBottomMargin = <td className="cell-width">{this.getBottomMargin(value, ownKeys)}</td>;
        }

        //LL: dataType_current instead of dataType   also for dataTypePure, dataTimePart
        let thTickInterval;
        let thTickIntervalType;
        let thTickIntervals;
        let tdTickInterval;
        let tdTickIntervalType;
        let tdTickIntervals;

        if (dataType_current === 'datetime' || dataType_current === 'date' || dataType_current === 'time') {
            thTickIntervalType = <th className="cell-tickIntervalType">{'Tick Interval Type'}</th>;
            thTickIntervals = <th className="cell-tickInterval">{'Tick Intervals'}</th>;
            tdTickIntervalType = (
                <td className="cell-tickIntervalType">
                    {this.getTickDateIntervalType(value, dataType_current, ownKeys)}
                </td>
            );
            tdTickIntervals = <td className="cell-tickInterval">{this.getTickDateIntervals(value, ownKeys)}</td>;
        } else {
            thTickInterval = (
                <th className="cell-tickInterval" title="Tick Interval (leave empty for automatic)">
                    {'Tick Interval'}
                </th>
            );
            tdTickInterval = (
                <td className="cell-tickInterval">
                    {this.getTickInterval(
                        value,
                        dataTypePure_current,
                        dataTimePart_current,
                        fullStackedOnAxis,
                        ownKeys
                    )}
                </td>
            );
        }

        //   Applies only to the axes of the "continuous" and "logarithmic" types.
        const thAxisDivisionFactor = (
            <th
                className="cell-tickInterval"
                title="Minimum distance between two neighboring major ticks in pixels (leave empty for automatic)"
            >
                {'Axis Division Factor'}
            </th>
        );
        const tdAxisDivisionFactor = (
            <td className="cell-tickInterval">
                {this.getAxisDivisionFactor(
                    value,
                    dataTypePure_current,
                    dataTimePart_current,
                    fullStackedOnAxis,
                    ownKeys
                )}
            </td>
        );

        let thBubbleFormat;
        let tdBubbleFormat;
        let thBubblePrecision;
        let tdBubblePrecision;
        let hasBubble = false;

        if (kind === 'y' || kind === 'Y') {
            if (
                props_values != null &&
                this.props.options != null &&
                typeof this.props.options.hasAxis_Bubble_Func === 'function'
            ) {
                hasBubble = this.props.options.hasAxis_Bubble_Func(props_values);
            }
        }
        if (kind === 'a' || kind === 'A') {
            if (
                props_values != null &&
                this.props.options != null &&
                typeof this.props.options.hasAxis_Bubble_Func === 'function'
            ) {
                hasBubble = this.props.options.hasAxis_Bubble_Func(props_values, this.props.options.name);
            }
        }

        if (hasBubble) {
            thBubbleFormat = <th className="cell-labelFormat">{'Bubble Size Format'}</th>;
            tdBubbleFormat = <td className="cell-labelFormat">{this.getBubbleSizeFormat(value, ownKeys)}</td>;
            thBubblePrecision = <th className="cell-minorTickCount">{'Bubble Size Precision'}</th>;
            tdBubblePrecision = (
                <td className="cell-minorTickCount">{this.getBubbleSizePrecision_NumberField(value, ownKeys)}</td>
            );
        }

        let showLabelPrecision = dataType_current === 'i' || dataType_current === 'r';
        let thLabelPrecision;
        let tdLabelPrecision;

        if (showLabelPrecision) {
            //  title="Label Precision (leave empty for default (0))"
            thLabelPrecision = <th className="cell-labelPrecision">{'Label Precision'}</th>;
            tdLabelPrecision = (
                <td className="cell-labelPrecision">
                    {this.getLabelPrecision_NumberField(value, dataType_current, ownKeys)}
                </td>
            );
        }

        const showCustomFormat = value.labelFormat === 'custom';

        let thCustomFormat;
        let tdCustomFormat;

        if (showCustomFormat) {
            let rf = 'http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table';

            thCustomFormat = (
                <th className="cell-customFormat" title={rf}>
                    {'Custom Format'}
                </th>
            );

            let tcf = value.customFormat || '';

            tdCustomFormat = (
                <td className="cell-customFormat" title={tcf}>
                    {this.getCustomFormat(value, ownKeys)}
                </td>
            );
        }

        //LL: dataType_current instead of dataType   also for dataTypePure, dataTimePart

        //LL: local currency, when labelFormat = "currency"
        let showLabelCurrency =
            (dataType_current === 'i' || dataType_current === 'r') && value.labelFormat === 'currency';
        let thLabelCurrency;
        let tdLabelCurrency;

        if (showLabelCurrency) {
            //LL: see https://js.devexpress.com/Documentation/ApiReference/Common/Object_Structures/format/#currency
            let thlc = 'Currency code accepts a 3-letter in ISO 4217';
            thLabelCurrency = (
                <th className="cell-customFormat" title={thlc}>
                    {'Label Currency'}
                </th>
            );
            let tdlc = 'default is ' + this.props.themeObj[themeVars.currencySelector];
            tdLabelCurrency = (
                <td className="cell-customFormat" title={tdlc}>
                    {this.getLabelCurrency(value, dataType_current, ownKeys)}
                </td>
            );
        }

        let class_minValue = 'cell-minValue';

        if (dataTypePure_current === 'datetime' || dataTypePure_current === 'date' || dataTypePure_current === 'time') {
            class_minValue = 'cell-minValueDate';
        }

        let class_synchronizedOn = 'cell-synchronizedOn';

        if (dataTypePure_current === 'datetime' || dataTypePure_current === 'date' || dataTypePure_current === 'time') {
            class_synchronizedOn = 'cell-minValueDate';
        }

        let thSynchOn;
        let tdSynchOn;

        if (((kind === 'y' || kind === 'Y') && multiAxis) || kind === 'a' || kind === 'A') {
            thSynchOn = (
                <th className={class_synchronizedOn} title="Synchronized On">
                    {'Synch On'}
                </th>
            );
            tdSynchOn = (
                <td className={class_synchronizedOn}>
                    {this.getSynchronizedOn(
                        value,
                        kind,
                        dataTypePure_current,
                        multiAxis,
                        synchronizeMultiAxes,
                        ownKeys
                    )}
                </td>
            );
        }

        const row20 = (
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-fontFace">{'Font Face'}</th>
                        <th className="cell-fontSize">{'Font Size'}</th>
                        <th className="cell-fontWeight">{'Font Weight'}</th>
                        <th className="cell-fontItalic">{'Italic'}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="cell-fontFace">{this.getFontFace(value, ownKeys)}</td>
                        <td className="cell-fontSize">{this.getFontSize(value, ownKeys)}</td>
                        <td className="cell-fontWeight">{this.getFontWeight(value, ownKeys)}</td>
                        <td className="cell-fontItalic">{this.getFontItalic(value, ownKeys)}</td>
                    </tr>
                </tbody>
            </table>
        );

        //LL: dataType_current instead of dataType
        const row2 = (
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-labelFormat">{'Label Format'}</th>
                        {thCustomFormat}
                        {thLabelCurrency}
                        {thLabelPrecision}
                        {thBubbleFormat}
                        {thBubblePrecision}
                        {thTickInterval}
                        {thTickIntervalType}
                        {thTickIntervals}
                        <th className="cell-minorTickCount" title="Minor Tick Count (integer > 0)">
                            {'Minor Tick Count'}
                        </th>
                        {thAxisDivisionFactor}
                        <th className={class_minValue}>{'Min Value'}</th>
                        <th className={class_minValue}>{'Max Value'}</th>
                        {thSynchOn}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="cell-labelFormat">{this.getLabelFormat(value, dataType_current, ownKeys)}</td>
                        {tdCustomFormat}
                        {tdLabelCurrency}
                        {tdLabelPrecision}
                        {tdBubbleFormat}
                        {tdBubblePrecision}
                        {tdTickInterval}
                        {tdTickIntervalType}
                        {tdTickIntervals}
                        <td className="cell-minorTickCount">{this.getMinorTickCount_NumberField(value, ownKeys)}</td>
                        {tdAxisDivisionFactor}
                        <td className={class_minValue}>
                            {this.getMinValue_allowNull(value, dataTypePure_current, fullStackedOnAxis, ownKeys)}
                        </td>
                        <td className={class_minValue}>
                            {this.getMaxValue_allowNull(value, dataTypePure_current, fullStackedOnAxis, ownKeys)}
                        </td>
                        {tdSynchOn}
                    </tr>
                </tbody>
            </table>
        );

        //   Applies only if the axis' type is "continuous" or "logarithmic".
        //   Does not apply to a multi-axis chart.
        let hasBreaks = kind === 'x' || kind === 'X' || kind === 'y' || kind === 'Y';
        let row3;

        //LL: hidden when type = discrete or automatic-discrete
        if (hasBreaks && value.type === 'discrete') {
            hasBreaks = false;
        }
        if (hasBreaks && (value.type == null || value.type === 'default')) {
            //LL:  wrong    can be "month"
            if (
                !(
                    dataTypePure_current === 'i' ||
                    dataTypePure_current === 'r' ||
                    dataTypePure_current === 'datetime' ||
                    dataTypePure_current === 'date' ||
                    dataTypePure_current === 'time'
                )
            ) {
                hasBreaks = false;
            }
        }

        if (hasBreaks && multiAxis === true && forActualChart) {
            hasBreaks = false;
        }

        if (hasBreaks) {
            const hasAutoBreaks = kind === 'y' || kind === 'Y';
            const style13: React.CSSProperties = {
                display: 'inline-table',
                width: 'auto',
                marginLeft: '16px'
            };
            let styleB = { marginLeft: '6px' };
            let thAuto, tdAuto;

            if (hasAutoBreaks) {
                thAuto = <th className="cell-inverted">{'Auto'}</th>;
                tdAuto = <td className="cell-inverted">{this.getBreaksAutoEnabled(value, ownKeys)}</td>;
            }

            let thAutoMaxCount;
            let tdAutoMaxCount;

            if (hasAutoBreaks) {
                thAutoMaxCount = <th className="cell-breaksAutoMaxCount">{'Auto Max Count'}</th>;
                tdAutoMaxCount = (
                    <td className="cell-breaksAutoMaxCount">{this.getBreaksAutoMaxCount(value, ownKeys)}</td>
                );
            }

            let row3_table = (
                <table className="table" style={style13}>
                    <thead>
                        <tr>
                            {thAuto}
                            {thAutoMaxCount}
                            <th className="cell-breaksLineStyle">{'Line Style'}</th>
                            <th className="cell-width">{'Width'}</th>
                            <th className="cell-color">{'Color'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {tdAuto}
                            {tdAutoMaxCount}
                            <td className="cell-breaksLineStyle">{this.getBreaksLineStyle(value, ownKeys)}</td>
                            <td className="cell-width">{this.getBreaksWidth(value, ownKeys)}</td>
                            <td className="cell-color">{this.getBreaksColor(value, ownKeys)}</td>
                        </tr>
                    </tbody>
                </table>
            );

            row3 = (
                <div>
                    <strong style={styleB}>{'Breaks formatting:'}</strong>
                    {row3_table}
                </div>
            );
        }

        let tableR_row3;

        if (row3 != null) {
            tableR_row3 = (
                <tr>
                    <td colSpan={1} className="filter-container">
                        {row3}
                    </td>
                </tr>
            );
        }

        let tableR = (
            <table className="table">
                <tbody>
                    <tr>
                        <td colSpan={1} className="dataDescriptor-container">
                            <div className="row0-container container" style={styleRow0}>
                                <div className="row">
                                    {axisType_Elem}
                                    {show_Elem}
                                    {showLine_Elem}
                                    {showLabels_Elem}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={1} className="dataDescriptor-container" style={{ paddingTop: '10px' }}>
                            <div className="row0-container container" style={styleRow01}>
                                <div className="row">
                                    {showAxisTicks_Elem}
                                    {showMinorTicks_Elem}
                                    {showGridLines_Elem}
                                    {showMinorGridLines_Elem}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={1} className="dataDescriptor-container" style={{ paddingTop: '10px' }}>
                            <table className="table" style={styleRow1}>
                                <thead>
                                    <tr>
                                        <th className="cell-title">{'Title'}</th>
                                        <th className="cell-inverted">{'Inverted'}</th>
                                        <th className="cell-position">{'Position'}</th>
                                        <th className="cell-width">{'Width'}</th>
                                        <th className="cell-color">{'Color'}</th>
                                        <th className="cell-color">{'Label Color'}</th>
                                        {thColorSeries}
                                        {thTopMargin}
                                        {thBottomMargin}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="cell-title">{this.getTitle(value, ownKeys)}</td>
                                        <td className="cell-inverted">{this.getInverted(value, ownKeys)}</td>
                                        <td className="cell-position">
                                            {this.getPosition(value, rotated, kind, ownKeys)}
                                        </td>
                                        <td className="cell-width">{this.getWidth(value, ownKeys)}</td>
                                        <td className="cell-color">{this.getColor(value, ownKeys)}</td>
                                        <td className="cell-color">{this.getColorLabels(value, ownKeys)}</td>
                                        {tdColorSeries}
                                        {tdTopMargin}
                                        {tdBottomMargin}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={1} className="filter-container" style={{ paddingTop: '10px' }}>
                            {row2}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={1} className="filter-container" style={{ paddingTop: '10px' }}>
                            {row20}
                        </td>
                    </tr>
                    {tableR_row3}
                </tbody>
            </table>
        );

        let useRemove = !(kind === 'x' || kind === 'X' || kind === 'y' || kind === 'Y'); // (kind === 'a' || kind === 'A')
        let canRemove = useRemove;

        if (canRemove) {
            if (this.props.options.canRemove != null) {
                canRemove = this.props.options.canRemove;
            }
        }

        let useInheritedButton = false;

        if (useRemove) {
            if (this.props.options.useInheritedButton != null) {
                useInheritedButton = this.props.options.useInheritedButton;
            }
        }

        //LL: for AUX: new useInheritedButton
        let removeButtonElem_inHeader = (
            <div
                className="cell-remove"
                style={{
                    display: 'inline-block',
                    marginTop: 1,
                    marginLeft: 10,
                    marginRight: 10
                }}
            >
                {this.getRemoveButton(useRemove, canRemove, useInheritedButton)}
            </div>
        );

        //let style4 = { width: '2rem' }; //  NEW, see .cell-tdLeft width: 160;  .cell-remove width: 1rem
        //  if (!forActualChart) dataTypeElem_inHeader IS NOT shown, will be predefinedDataTypeElem_inHeader (see below)
        //  if (forActualChart) dataTypeElem_inHeader IS shown
        let dataTypeElem_inHeader;

        if (forActualChart) {
            //LL: display either dataTypeStr or dataTypePredefinedStr, when canRemove
            let dataType_Value;

            if (showPredefinedDataType) {
                //LL: only can be for "a" kind
                if (dataTypePredefined != null) {
                    //  not null here always
                    dataType_Value = dataTypePredefinedStr;
                }
            } else {
                dataType_Value = dataTypeStr;
            }

            dataTypeElem_inHeader = <span className="chartaxis-field-header-element">{dataType_Value}</span>;
        }

        //LL:  also see in sass:  background-color: #f5f5f5  //  #f5f5f5 is the same as .breadcrumbs,  as .card-header
        let headerBgColor = this.props.themeObj['panel-header-bg']; // bootstrapTheme.ts  return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
        let styleHeader: React.CSSProperties = {};

        if (headerBgColor != null) {
            styleHeader.backgroundColor = headerBgColor;
        }

        let wrongAxisTypeErrorElem;

        if (this.state.wrongAxisType != null) {
            wrongAxisTypeErrorElem = (
                <div style={{ color: 'red', marginBottom: '8px' }}>
                    {'Saved Axis Type "' +
                        this.state.wrongAxisType +
                        '" is incompatible with DataType' +
                        ' and is temporary set to "automatic". Choose correct Axis Type or just save for "automatic".'}
                </div>
            );
        }

        let styleD = { borderTop: '1px dashed #d3d3d3', paddingTop: 5 };

        return (
            <div className={'chartaxis-field'} style={styleD}>
                <div className={'div-container'}>
                    <div className="chartaxis-field-common"></div>
                    {compatibilityErrorElem}
                    {wrongAxisTypeErrorElem}
                    <div className="chartaxis-field-header-container" style={styleHeader}>
                        {removeButtonElem_inHeader}
                        <span className="chartaxis-field-header-element">
                            <strong>{name_Value}</strong>
                        </span>

                        {dataTypeElem_inHeader}
                        <span className="chartaxis-field-header-element"> {predefinedDataTypeElem} </span>
                    </div>

                    <table className="table chartaxis-field-table-container">
                        <tbody>
                            <tr>
                                <td colSpan={1} className="dataDescriptor-container">
                                    {tableR}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="chartaxis-field-footer-container">{applyFromPredefinedElem_inFooter}</div>
                </div>
            </div>
        );
    }
}
